/* eslint-disable max-len */
import Translation from './types'

const sv: Translation = {
  common: {
    like: 'Gilla',
    likes: 'Gillar',
    makeComment: 'Kommentera',
    comment: 'Kommentar',
    comments: 'Kommentarer',
    settings: 'Inställningar',
    yes: 'Ja',
    no: 'Nej',
    options: 'Alternativ',
    active: 'Aktiv',
    in: 'i',
    time: 'Tid',
    hour: 'Timme',
    minute: 'Minut',
    description: 'Beskrivning',
    profile: 'Profil',
    loading: 'Laddar...',
    newFeature: 'Nyhet!',
    showMore: 'Visa mer',
    showLess: 'Visa mindre',
    actions: {
      save: 'Spara',
      edit: 'Redigera',
      change: 'Ändra',
      delete: 'Radera',
      cancel: 'Avbryt',
      send: 'Skicka',
      publish: 'Publicera',
      update: 'Uppdatera',
      confirm: 'Bekräfta',
      create: 'Skapa',
      add: 'Lägg till',
      addMore: 'Lägg till fler',
      remove: 'Ta bort',
      accept: 'Acceptera',
      deny: 'Neka',
      continue: 'Fortsätt',
      leave: 'Lämna',
      join: 'Gå med',
      skip: 'Hoppa över',
      select: 'Välj',
      done: 'Klar',
      close: 'Stäng',
      show: 'Visa',
      tryAgain: 'Försök igen',
      later: 'Senare',
      logout: 'Logga ut',
      back: 'Tillbaka',
      invite: 'Bjud in',
      message: 'Meddelande',
      upload: 'Ladda upp',
      activate: 'Aktivera',
      copyText: 'Kopiera text',
      print: 'Skriv ut',
      report: 'Rapportera',
      order: 'Beställ',
      pay: 'Betala',
      book: 'Boka',
      bookAsAdmin: 'Boka som admin',
      saveChanges: 'Spara ändringarna',
      clear: 'Rensa',
      download: 'Ladda ner',
      pin: 'Fäst överst',
      unpin: 'Lossa',
    },
    form: {
      labels: {
        name: 'Namn',
        surname: 'Efternamn',
        email: 'Mejladress',
        message: 'Meddelande',
        entrance: 'Adress',
        entrance_samf: 'Väg',
        unit: 'Lägenhetsnummer',
        unit_samf: 'Fastighetsbeteckning',
        unitRole: 'Roll',
        active: 'Aktiv',
        organisationNumber: 'Organisationsnummer',
        reference: 'Referens',
        society: 'Förening',
        society_lgh: 'Fastighet',
        password: 'Lösenord',
        role: 'Roll',
        addressCity: 'Postort',
        addressZip: 'Postnummer',
        addressStreet: 'Adressrad 2',
        addressStreet1: 'Adressrad 1',
        addressCareOf:
          'Adressrad 1   (här lägger du id för ekonomisk förvaltare)',
        type: 'Typ',
        from: 'Från',
        to: 'Till',
        discount: 'Rabatt',
        gender: 'Kön',
        phoneNumber: 'Telefonnummer',
      },
      helperTexts: {
        calculatedAutomatically: 'Beräknas automatiskt',
      },
      note: {
        required: '*Obligatoriskt',
        locked: 'Låst',
      },
      upload: {
        preparing: 'Förbereder...',
        uploading: 'Laddar upp...',
        failedFiles: 'Följande filer kunde inte laddas upp',
        success: 'Filer uppladdade',
        someFilesFailed: 'Vissa filer kunde inte laddas upp',
        invalidType: 'Filtypen stöds inte',
        fileTooLarge: 'Filen är för stor',
        genericError: 'Kunde inte laddas upp',
      },
    },
    fee: {
      annually: 'Årsvis',
      discountViaString: 'Rabatt via {{ partnerName }}',
    },
    boardDisabledFeature:
      'Föreningen har valt att avaktivera den här funktionen.',
    boardDisabledFeature_lgh:
      'Fastigheten har valtatt avaktivera den här funktionen.',
    copiedToClipboard: 'Kopierat',
    unit: {
      unassigned: 'Icke tilldelad',
    },
    // TODO: Update translations
    emptyState: {
      title: 'Det finns inget att visa.',
      subtitle: 'Det finns för närvarande inget att visa på denna vy!',
    },
    platform: {
      webapp: 'Webbapp',
      mobileApp: 'Mobilapp',
    },
    eventActions: {
      attendance: {
        comment: 'Kommentar',
        attending: 'Kommer',
        notAttending: 'Kan inte komma',
        updateComment: 'Uppdatera Kommentar',
      },
    },
    contactActions: {
      call: 'Ring',
      email: 'Mejla',
      website: 'Hemsida',
    },
    contact: {
      phoneNumber: 'Telefonnummer',
      email: 'Mejladress',
      website: 'Hemsida',
    },
    days: {
      singular: 'dag',
      plural: 'dagar',
    },
    callout: {
      namedSocietyLocked: {
        title: '{{ societyName }} är låst',
      },
    },
    button: {
      save: 'Spara',
      send: 'Skicka',
      delete: 'Radera',
      next: 'Nästa',
      previous: 'Föregående',
      close: 'Stäng',
      addMore: 'Lägg till fler',
      toPayment: 'Till betalning',
    },
    other: 'Annat',
    none: 'Ingen',
    weekDays: {
      monday: 'Måndag',
      tuesday: 'Tisdag',
      wednesday: 'Onsdag',
      thursday: 'Torsdag',
      friday: 'Fredag',
      saturday: 'Lördag',
      sunday: 'Söndag',
    },
    languages: {
      english: 'Engelska',
      swedish: 'Svenska',
    },
    prefixes: {
      you: 'Du',
    },
    notificationSettings: {
      label: 'Informera boende',
      labelBoard: 'Informera styrelse',
      labelBoard_lgh: 'Informera förvaltare',
      none: 'Nej',
      feed: 'Flöde',
      notificationAndFeed: 'Notiser & flöde',
      notification: 'Notis',
    },
    user: {
      deletedUserName: 'Borttagen användare',
      admin: 'Admin',
      masterAdmin: 'Huvudadministratör',
    },
    numberOfunits: {
      apartmentBuilding: 'Antal lägenheter',
      boatClub: 'Antal medlemmar',
      economicAssociation: 'Antal fastigheter',
      homeownersAssociatoon: 'Antal fastigheter',
      housingCooperative: 'Antal lägenheter',
      housingCooperativeConstruction: 'Antal lägenheter',
      neighbourhood: 'Antal fastigheter',
      nonProfitAssociation: 'Antal fastigheter',
      shared: 'Antal nyttjare',
    },
    errorViews: {
      userNotInSociety: {
        title: 'Inte medlem i en förening',
        title_lgh: 'Inte hyregäst i en fastighet',
        subtitle:
          'Ansök om att gå med i din förening under fliken "Förening" för att kunna chatta med dina grannar.',
        subtitle_lgh:
          'Ansök om att gå med i din fastighet under fliken "Fastighet" för att kunna chatta med dina grannar.',
      },
      pendingRequest: {
        title: 'Inväntar bekräftelse från styrelsen',
      },
    },
    singularPlural: {
      years: {
        singular: 'År',
        plural: 'År',
      },
      unit: {
        singular: 'Lägenhet',
        plural: 'Lägenheter',
        singular_samf: 'Fastighet',
        plural_samf: 'Fastigheter',
      },
      like: {
        singular: 'Gillar',
        plural: 'Gillar',
      },
      connected: {
        singular: 'kopplad',
        plural: 'kopplade',
      },
      person: {
        singular: 'Person',
        plural: 'Personer',
      },
    },
    terms: {
      user: 'Användarvillkor',
      service: 'Tjänstevillkor',
      dataProcessing: 'Personuppgiftsbehandling',
    },
  },
  registerGuidanceView: {
    title_samf: 'Så får ni ordning på fastighetsregistret',
    title: 'Så får ni ordning på lägenhetsregistret',
    subTitle_samf:
      'Ett korrekt fastighetsregister är grundläggande för användningen av Boappa. Alla fastigheter behöver ha rätt adress och korrekt fastighetsbeteckning.',
    subTitle:
      'Ett korrekt lägenhetsregister är grundläggande för användningen av Boappa. Alla lägenheter behöver ha rätt adress och lantmäteriets fyrsiffriga nummer.',
    description:
      'Lägenhetsregistret behöver vara komplett för att all funktionalitet i Boappa ska fungera och det är också genom lägenhetsregistret styrelsen ser ifall alla hushåll är representerade i Boappa.',
    description_samf:
      'Fastighetsregistret behöver vara komplett för att all funktionalitet i Boappa ska fungera och det är också genom fastighetsregistret styrelsen ser ifall alla fastigheter är representerade i Boappa.',
    address:
      'i styrelseportalen och kontrollera att föreningens alla adresser är upplagda.',
    address_samf:
      'i styrelseportalen och kontrollera att föreningens alla vägar är upplagda.',
    link: 'Klicka sedan på “Fastigheter” och lägg upp de beteckningar som saknas.',
    link_samf:
      'Klicka sedan på “Lägenhetsnummer” och lägg upp de nummer som saknas.',
    ifMany:
      'Om ni har många lägenhetsnummer att lägga upp görs det enklast via en excel-fil i webbappen.',
    ifMany_samf:
      'Om ni har många fastigheter att lägga upp görs det enklast via en excel-fil i webbappen.',
    tips: 'Tips,',
    support: 'Kontakta vår support om ni behöver hjälp med registret.',
    goto: 'Gå till',
    register: 'Register',
    howToDo: 'Så här gör du',
  },
  blockedCallout: {
    message:
      'Du har inte behörighet att publicera innehåll i {{ societyNames }}.',
  },
  societyType: {
    housingCooperative: 'Bostadsrättsförening',
    housingCooperativeConstruction: 'Projekt (bostadsutvecklare)',
    homeOwnersAssociation: 'Samfällighet',
    nonProfitAssociation: 'Ideell förening',
    economicAssociation: 'Ekonomisk förening',
    neighbourhood: 'Grannskap',
    apartmentBuilding: 'Hyresfastighet',
  },
  accordionSection: {
    defaultItemsEmptyText: 'Denna sektion är tom',
  },
  select: {
    noOptions: 'Inga alternativ',
  },
  offlineView: {
    title: 'Du är offline.',
    subtitle:
      'Se över din internetanslutning och försök igen genom att ladda om sidan.',
  },
  notFoundView: {
    title: 'Ojdå! Du har besökt en sida som inte finns.',
    subtitle:
      'Vi ber om ursäkt. Vänligen klicka på gå tillbaka och försök igen.',
    buttonLabel: 'Gå tillbaka',
  },
  unauthorizedView: {
    title: 'Du har inte tillåtelse att se denna sida.',
    subtitle:
      'Detta beror på att du inte har den roll som krävs för åtkomst av innehållet.',
    buttonLabel: 'Gå tillbaka',
  },
  chatView: {
    title: 'Chatt',
  },
  chatMessageReadBy: {
    readBy: 'Läst av',
    modalTitle: 'Meddelande läst av',
    more: 'och {{count}} till',
  },
  chatRoom: {
    flashMessage: {
      noAccess: 'Du har inte längre tillgång till den här chatten',
    },
    composer: {
      notMember: 'Gå med i chatten för att skicka meddelanden',
    },
    emptyState: {
      noMessages: 'Inga meddelanden ännu',
    },
  },
  registerView: {
    title: 'Register',
    upload: 'Ladda upp register',
    tabBar: {
      entrances: 'Adresser',
      entrances_samf: 'Vägar',
      unit: 'Lägenhetsnummer',
      unit_samf: 'Fastigheter',
      members: 'Medlemmar',
      members_lgh: 'Hyresgäster',
      nonMembers: 'Övriga användare',
      groups: 'Grupper',
    },
    unit: {
      labels: {
        entrance: 'Adress',
        entrance_samf: 'Väg',
        unit: 'Lägenhetsnummer',
        unit_samf: 'Fastighet',
        title: 'Lägenhetsnummer (föreningen)',
        title_lgh: 'Lägenhetsnummer (fastigheten)',
        title_samf: 'Adress',
        titleLegal: 'Lägenhetsnummer (lantmäteriet)',
        titleLegal_samf: 'Fastighetsbeteckning',
        floor: 'Våning',
      },
      warnings: {
        noResidents: 'Det finns ingen boende kopplad till denna',
      },
    },
    group: {
      unitsSingular: 'lägenhetsnummer',
      unitsPlural: 'lägenhetsnummer',
      membersSingular: 'Medlem',
      membersPlural: 'Medlemmar',
    },
    emptyState: {
      member: {
        title: 'Inga användare tillagda.',
        noSearchResults: 'Inga sökresultat hittades.',
      },
    },
    alert: {
      removeUserTitle: 'Ta bort boende',
      removeUserTitle_lgh: 'Ta bort hyregäst',
      removeUserText: 'Vill du ta bort {{ name }} från föreningen?',
      removeUserText_lgh: 'Vill du ta bort {{ name }} från fastigheten?',
    },
    flashMessage: {
      removeUserSuccess: 'Personen har tagits bort från föreningen',
      removeUserSuccess_lgh: 'Personen har tagits bort från fastigheten',
      removeUserFailure: 'Personen kunde inte tas bort från föreningen',
      removeUserFailure_lgh: 'Personen kunde inte tas bort från fastigheten',
    },
  },
  registerEntrance: {
    modal: {
      create: 'Lägg till address',
      create_samf: 'Lägg till väg',
      update: 'Uppdatera adress',
      update_samf: 'Uppdatera väg',
    },
    form: {
      labels: {
        addressStreet: 'Adress',
        addressStreet_samf: 'Väg',
      },
    },
    numberOfUnits:
      'Det finns {{ number }} {{ unitText }} {{connectText}} till denna adress',
    numberOfUnits_samf:
      'Det finns {{ number }} {{ unitText }} {{connectText}} till denna väg',
    confirmationDialog: {
      deleteTitle: 'Radera adress',
      deleteDescription: 'Är du säker på att du vill radera adressen?',
      deleteTitle_samf: 'Radera väg',
      deleteDescription_samf: 'Är du säker på att du vill radera vägen?',
    },
    warnings: {
      unableDeleteWithUnits:
        'Adresser med kopplade lägenhetsnummer kan inte raderas.',
      unableDeleteWithUnits_samf:
        'Vägar med kopplade fastigheter kan inte raderas.',
      unableToDeleteWithUnassigned:
        'Kan inte ta bort denna adress. Den innehåller alternativet för otilldelat lägenhetsnummer, som kan användas för användare som inte har en angiven adress.',
      unableToDeleteWithUnassigned_samf:
        'Kan inte ta bort denna väg. Den innehåller alternativet för otilldelad fastighet, som kan användas för användare som inte har en angiven fastighet.',
    },
    flashMessage: {
      createEntranceFailure: 'Adressen kunde inte skapas',
      createEntranceSuccess: 'Adressen skapad',
      updateEntranceFailure: 'Adressen kunde inte uppdateras',
      updateEntranceSuccess: 'Adressen uppdaterad',
      deleteEntranceFailure: 'Adressen kunde inte tas bort',
      deleteEntranceSuccess: 'Adress borttagen',
      createEntranceFailure_samf: 'Vägen kunde inte skapas',
      createEntranceSuccess_samf: 'Väg skapad',
      updateEntranceFailure_samf: 'Vägen kunde inte uppdateras',
      updateEntranceSuccess_samf: 'Väg uppdaterad',
      deleteEntranceFailure_samf: 'Vägen kunde inte tas bort',
      deleteEntranceSuccess_samf: 'Väg borttagen',
    },
  },
  preApproved: {
    title: 'Inbjudningar',
    subtitle: 'Här kan du se alla inbjudningar som ännu inte blivit besvarade',
    buttons: {
      remindAllTitle: 'Påminn samtliga',
    },
    confirmationDialog: {
      deleteTitle: 'Återkalla inbjudan',
      deleteDescription: 'Vill du återkalla inbjudan?',
      remindTitle: 'Skicka påminnelse',
      remindDescription: 'Vill du skicka en påminnelse?',
      remindAllTitle: 'Skicka påminnelse',
      remindAllDescription:
        'Vill du skicka en påminnelseinbjudan till samtliga?',
    },
    flashMessage: {
      sendReminderFailure: 'Påminnelsen kunde inte skickas',
      sendReminderSuccess: 'Påminnelse skickad',
      remindAllFailure: 'Påminnelserna kunde inte skickas',
      remindAllSuccess: 'Samtliga påminnelser skickade',
      deletePreApprovedFailure: 'Inbjudan kunde inte återkallas',
      deletePreApprovedSuccess: 'Inbjudan återkallad',
    },
  },
  registerUnit: {
    modal: {
      create: 'Lägg till lägenhetsnummer',
      create_samf: 'Lägg till fastighet',
      update: 'Uppdatera lägenhetsnummer',
      update_samf: 'Uppdatera fastighet',
      residents: 'Boende',
      residents_lgh: 'Hyregäster',
    },
    confirmationDialog: {
      deleteTitle: 'Radera lägenhetsnummer',
      deleteDescription: 'Är du säker på att du vill radera lägenhetsnumret?',
      deleteTitle_samf: 'Radera fastighet',
      deleteDescription_samf: 'Är du säker på att du vill radera fastigheten?',
      deleteDescriptionWithBinder:
        'Är du säker på att du vill radera lägenhetsnumret? Det finns en bopärm kopplad till detta lägenhetsnummer.',
      deleteDescriptionWithBinder_samf:
        'Är du säker på att du vill radera fastigheten? Det finns en bopärm kopplad till denna fastighet.',
    },
    flashMessage: {
      createUnitFailure: 'Lägenhetsnumret kunde inte skapas',
      createUnitSuccess: 'Lägenhetsnummer skapat',
      updateUnitFailure: 'Lägenhetsnumret kunde inte uppdateras',
      updateUnitSuccess: 'Lägenhetsnummer uppdaterat',
      deleteUnitFailure: 'Lägenhetsnumret kunde inte tas bort',
      deleteUnitSuccess: 'Lägenhetsnummer borttaget',
      createUnitFailure_samf: 'Fastigheten kunde inte skapas',
      createUnitSuccess_samf: 'Fastighet skapad',
      updateUnitFailure_samf: 'Fastigheten kunde inte uppdateras',
      updateUnitSuccess_samf: 'Fastighet uppdaterad',
      deleteUnitFailure_samf: 'Fastigheten kunde inte tas bort',
      deleteUnitSuccess_samf: 'Fastighet borttagen',
    },
  },
  registerRequest: {
    modal: {
      title: 'Medlemsförfrågningar',
    },
    flashMessage: {
      approveRequestSuccess: 'Förfrågan godkänd',
      approveRequestFailure: 'Förfrågan kunde inte godkännas',
      denyRequestSuccess: 'Förfrågan nekad',
      denyRequestFailure: 'Förfrågan kunde inte nekas',
    },
  },
  adminWebinar: {
    options: {
      gettingStarted: 'Kom-igång',
      intro: 'Intro',
      newBoard: 'Ny styrelsemedlem',
    },
  },
  registerExcelImport: {
    modal: {
      entranceUnitTitle: 'Lägenhetsregister',
      entranceUnitTitle_samf: 'Fastighetsregister',
      memberTitle: 'Medlemsregister',
      memberTitle_lgh: 'Hyresgästregister',
      entranceUnitSubtitle: 'Uppdatera lägenhetsregister',
      entranceUnitSubtitle_samf: 'Uppdatera Fastighetsregister',
      entranceUnitDescription:
        'Bästa sättet att ändra många lägenheter är att ladda ner registret till Excel, göra ändringar där och sedan ladda upp igen till Boappa.',
      entranceUnitDescription_samf:
        'Bästa sättet att ändra många fastigheter är att ladda ner registret till Excel, göra ändringar där och sedan ladda upp igen till Boappa.',
      memberSubtitle: 'Uppdatera medlemsregister',
      memberSubtitle_lgh: 'Uppdatera hyresgästregister',
      memberDescription:
        '1. Ladda ner och fyll i medlemmarnas namn och mejladresser\n\n2. Ladda upp excelfilen och klicka på Spara\n\n3. Era medlemmar blir automatiskt inbjudna och kopplade till sina respektive lägenheter. Medlemmar som redan är inbjudna till Boappa kommer ej få en till inbjudan',
      memberDescription_lgh:
        '1. Ladda ner och fyll i hyresgästernas namn och mejladresser\n\n2. Ladda upp excelfilen och klicka på Spara\n\n3. Era hyresgäster blir automatiskt inbjudna och kopplade till sina respektive lägenheter. Hyresgäster som redan är inbjudna till Boappa kommer ej få en till inbjudan',
    },
    flashMessage: {
      uploadRegisterSuccess: 'Register uppladdat',
      uploadRegisterFailure: 'Registret kunde inte laddas upp',
    },
  },
  registerInvite: {
    modal: {
      inviteMember: 'Bjud in medlem',
      inviteMember_lgh: 'Bjud in hyregäst',
      inviteNonMember: 'Bjud in övrig användare',
    },
    form: {
      unit: 'Lägenhetsnummer',
      unit_samf: 'Fastighet',
      inviteWithoutUnit: 'Bjud in utan bostad',
      inviteWithoutUnit_samf: 'Bjud in utan fastighet',
      unitMissingMessage: 'En Icke tilldelad bostad saknas för ',
      unitMissingMessage_samf: 'En Icke tilldelad fastighet saknas för ',
      inviteAsAdmin: 'Bjud in som administratör',
      inviteAsBoard: 'Bjud in som styrelsemedlem',
      inviteAsBoard_lgh: 'Bjud in som förvaltare',
    },
    flashMessage: {
      inviteSentFailure: 'Inbjudan kunde inte skickas',
      inviteSentSuccess: 'Inbjudan skickad',
    },
  },
  registerGroup: {
    modal: {
      create: 'Skapa grupp',
      update: 'Uppdatera grupp',
    },
    form: {
      labels: {
        name: 'Gruppnamn',
      },
      options: {
        type: {
          unit: 'Lägenhet',
          unit_samf: 'Fastighet',
          user: 'Användare',
        },
      },
    },
    confirmationDialog: {
      deleteTitle: 'Radera grupp',
      deleteDescription: 'Är du säker på att du vill radera gruppen?',
      changeTypeTitle: 'Uppdatera typ',
      changeTypeDescription:
        'Val i befintlig grupptyp kommer att raderas. Är du säker på att du vill ändra grupptypen?',
    },
    flashMessage: {
      deleteSuccess: 'Grupp raderad',
      deleteFailure: 'Gruppen kunde inte raderas',
      createSuccess: 'Grupp skapad',
      createFailure: 'Gruppen kunde inte skapas',
      updateSuccess: 'Grupp uppdaterad',
      updateFailure: 'Gruppen kunde inte uppdateras',
    },
  },
  gdprView: {
    title: 'GDPR',
    content:
      'På Boappa håller vi dataskydd och personlig integritet högt. Vi arbetar ständigt för att våra användares personuppgifter hanteras på ett korrekt sätt och vi hjälper er som förening att skydda era medlemmars personuppgifter. \n\nDet legala ramverket för personuppgiftsbehandling är GDPR (dataskyddsförordningen). \n\nNedan finner ni information, tips och kontaktuppgifter till Boappas dataskyddsansvarig.',
    content_lgh:
      'På Boappa håller vi dataskydd och personlig integritet högt. Vi arbetar ständigt för att våra användares personuppgifter hanteras på ett korrekt sätt och vi hjälper er att skydda era personuppgifter. \n\nDet legala ramverket för personuppgiftsbehandling är GDPR (dataskyddsförordningen). \n\nNedan finner ni information, tips och kontaktuppgifter till Boappas dataskyddsansvarig.',
    moreAbout: {
      title: 'Mer om GDPR',
    },
    personalDataAdvice: {
      title: 'Tips för er personuppgiftsbehandling',
    },
    boappaVendor: {
      title: 'Underleverantörer',
      description:
        'Det här är en lista över de underleverantörer som Boappa använder för att leverera tjänsten Boappa. Samtliga underleverantörer har anpassat sig för att följa GDPR.',
      vendors: {
        aws: {
          name: 'Amazon AWS',
          description: 'molntjänst för lagring av data med server inom EU/EES.',
        },
        billogram: {
          name: 'Billogram',
          description: 'tjänst som används för att skicka fakturor.',
        },
        mailchimp: {
          name: 'Mailchimp',
          description: 'tjänst för utgående mejlutskick.',
        },
        firebase: {
          name: 'Google Firebase',
          description:
            'tjänst som används för att skicka notiser i mobilappen.',
        },
        cloudflare: {
          name: 'Cloudfare',
          description:
            'tjänst som används leverera innehåller i tjänsten till appen.',
        },
      },
    },
    dataProtectionOfficer: {
      title: 'Dataskyddsansvarig',
    },
  },
  societyInformationView: {
    title: 'Om föreningen',
    title_lgh: 'Om fastigheten',
    formSections: {
      societyPicture: 'Föreningsbild',
      societyPicture_lgh: 'Fastighetsbild',
      societyTitle: 'Förening',
      societyTitle_lgh: 'Fastighet',
      addressTitle: 'Adress',
    },
    labels: {
      updateSocietyPicture: 'Uppdatera bild',
    },
  },
  societyContractsView: {
    title: 'Avtal',
    emptyState: {
      title: 'Det finns inga avtal',
      subtitle: 'Inga avtal har lagts till i föreningen.',
      subtitle_lgh: 'Inga avtal har lagts till i fastigheten.',
      noSearchResultsTitle: 'Hittade inga avtal',
      noSearchResultsSubtitle: 'Ändra ditt sökord och försök igen.',
    },
  },
  societyBoardMembersView: {
    title: 'Styrelsemedlemmar',
    title_lgh: 'Förvaltare',
    emptyState: {
      title: 'Det finns inga styrelsemedlemmar',
      title_lgh: 'Det finns inga förvaltare',
      subtitle: 'Inga styrelsemedlemmar ännu i föreningen.',
      subtitle_lgh: 'Inga förvaltare ännu i fastigheten.',
      noSearchResultsTitle: 'Hittade inga styrelsemedlemmar',
      noSearchResultsSubtitle: 'Ändra ditt sökord och försök igen.',
    },
  },
  societyContractDetailView: {
    emptyState: {
      title: 'Avtalet kunde inte hittas',
      subtitle: 'Du försökte gå in på ett avtal som inte finns.',
    },
  },
  societyStatisticsExportsView: {
    title: 'Statistik & utdrag',
    tabBar: {
      statistics: 'Statistik',
      exports: 'Utdrag',
    },
    statistics: {
      headerTitle: 'Aktivitet',
      numberLogins: 'Totalt antal inloggade',
      numberPosts: 'Totalt antal inlägg i flödet',
      numberLikes: 'Totalt antal gillanden',
      numberComments: 'Totalt antal kommentarer',
    },
    exports: {
      residentList: {
        headerTitle: 'Boende',
        headerTitle_lgh: 'Hyregäster',
        residentListDownload: 'Boendelistan',
        residentListDownload_lgh: 'Hyregästlista',
      },
      bookingsList: {
        headerTitle: 'Bokningar av faciliteter',
      },
    },
  },
  contactsView: {
    title: 'Kontakter',
    emptyState: {
      title: 'Det finns inga kontakter',
      subtitle: 'Inga kontakter har lagts till för föreningen.',
      subtitle_lgh: 'Inga kontakter har lagts till för fastigheten.',
      noSearchResultsTitle: 'Hittade inga kontakter',
      noSearchResultsSubtitle: 'Ändra ditt sökord och försök igen.',
    },
  },
  societyView: {
    title: 'Förening',
    title_lgh: 'Fastighet',
    emptyState: {
      noSociety: {
        title: 'Inte medlem i en förening',
        title_lgh: 'Inte medlem i en fastighet',
        subtitle:
          'Ansök om att gå med i din förening genom att klicka på knappen nedan.',
        subtitle_lgh:
          'Ansök om att gå med i din fastighet genom att klicka på knappen nedan.',
        buttonTitle: 'Hitta förening',
        buttonTitle_lgh: 'Hitta fastighet',
      },
      pendingRequest: {
        title: 'Inväntar bekräftelse från styrelsen',
        title_lgh: 'Inväntar bekräftelse från förvaltaren',
        subtitle:
          'Här kommer du kunna ta del av samlad information om din förening',
        subtitle_lgh:
          'Här kommer du kunna ta del av samlad information om din fastighet',
        buttonTitle: 'Hitta förening',
        buttonTitle_lgh: 'Hitta fastighet',
      },
    },
  },
  binderListView: {
    title: 'Bopärm',
  },
  residentListView: {
    title: 'Boendelista',
    joined: 'Gick med',
  },
  adminRightsView: {
    title: 'Adminrättigheter',
    makeMasterAdminTitle: 'Gör till huvudadministratör',
    flashMessage: {
      adminRemoveSuccess: 'Administratör borttagen',
      adminRemoveFailure: 'Administratör kunde inte tas bort',
      masterAdminChangedSuccess: 'Huvudadministratör ändrad',
      masterAdminChangedFailure: 'Huvudadministratör kunde inte ändras',
    },
    alert: {
      deleteAdminTitle: 'Radera administratör',
      deleteAdminText: 'Är du säker på att du vill radera administratören?',
      updateMasterAdminTitle: 'Uppdatera huvudadministratör',
      updateMasterAdminText:
        'Är du säker på att du vill ändra huvudadministratör?',
    },
    emptyState: {
      title: 'Inga admins',
      subtitle: 'Det finns för närvarande inga angivna admins',
      noSearchResultsTitle: 'Hittade inga admins',
      noSearchResultsSubtitle: 'Ändra ditt sökord och försök igen.',
    },
  },
  boardContactsView: {
    title: 'Styrelsekontakter',
    title_lgh: 'Förvaltarkontakter',
    emptyState: {
      title: 'Det finns inga kontakter',
      subtitle: 'Inga kontakter har lagts till för föreningen.',
      subtitle_lgh: 'Inga kontakter har lagts till för fastigheten.',
      noSearchResultsTitle: 'Hittade inga kontakter',
      noSearchResultsSubtitle: 'Ändra ditt sökord och försök igen.',
    },
  },
  boardCalendarView: {
    title: 'Styrelsekalender',
    title_lgh: 'Förvaltarkalender',
    emptyState: {
      title: 'Luta dig tillbaka, inget inbokat i kalendern.',
      subtitle: 'Just nu finns det inga inplanerade kalenderhändelser.',
    },
  },
  contactCard: {
    flashMessage: {
      deleteContactSuccess: 'Kontakt borttagen',
      deleteContactFailure: 'Kontakten kunde inte tas bort',
    },
    alert: {
      deleteContactTitle: 'Radera kontakt',
      deleteContactText: 'Är du säker på att du vill radera kontakten?',
    },
    call: 'Telefon:',
    email: 'Mejl:',
    website: 'Webbplats:',
  },
  marketplaceListView: {
    title: 'Köp & sälj',
    subtitle: 'Köp, sälj, hyr och låna ut',
    emptyState: {
      title: 'Ingen annons uppplagd ännu',
      subtitle:
        'Lägg upp en annons för att påbörja Köp & sälj-sidan. Du kan enkelt ta bort annonsen sen om du ångrar dig.',
      subtitleMissingUnit:
        'För att skapa en annons behöver du ha tillhöra ett boende i förening.',
      subtitleMissingUnit_lgh:
        'För att skapa en annons behöver du ha tillhöra ett boende i fastighet.',
    },
    noListingFound: {
      title: 'Ingen annons matchade din sökning',
      subtitle:
        'Pröva ett annat sökord eller ta bort din sökning för att åter se alla annonser.',
    },
    buttons: {
      createListing: 'Ny annons',
    },
    item: {
      free: 'Gratis',
    },
    flashMessage: {
      deleteResourceSuccess: 'Annons borttagen',
      deleteResourceFailure: 'Annonsen kunde inte tas bort',
    },
  },
  functionSettingsView: {
    title: 'Funktioner',
    subtitle:
      'Stäng av eller sätt på funktioner som boende skall se i vänstermenyn “För boende”.',
    table: {
      titles: {
        function: 'Funktion',
        visible: 'Visas för boende',
        visible_lgh: 'Visas för hyregäster',
      },
    },
    form: {
      labels: {
        function: 'Funktion',
        title: 'Titel',
        link: 'Länk',
        content: 'Innehåll',
      },
      widgetTypeOptions: {
        link: 'Länk',
        text: 'Text',
      },
    },
    buttons: {
      addFunction: 'Lägg till funktion',
    },
    modal: {
      createTitle: 'Skapa funktion',
      editTitle: 'Redigera funktion',
    },
    confirmationModal: {
      deleteTitle: 'Radera funktion',
      deleteDescription: 'Är du säker på att du vill radera funktionen?',
    },
    flashMessage: {
      deleteWidgetSuccess: 'Funktion borttagen',
      deleteWidgetFailure: 'Funktion kunde inte tas bort',
      updateWidgetSuccess: 'Funktion uppdaterad',
      updateWidgetFailure: 'Funktion kunde inte uppdateras',
      createWidgetSuccess: 'Funktion skapad',
      createWidgetFailure: 'Funktion kunde inte skapas',
    },
  },
  societyBlockedUsersView: {
    title: 'Blockerade användare',
    subtitle: `När en användare blockeras begränsas deras åtkomst till endast läsåtkomst. Det innebär att de kan se innehållet men kan inte skapa nya inlägg, kommentera befintliga inlägg eller använda chatten.

Detta bör endast användas i undantagsfall och en dialog med användaren bör föregå beslutet.`,
    flashMessage: {
      userBlockRemoveSuccess: 'Blockering borttagen',
      userBlockRemoveFailure: 'Blockeringen kunde inte tas bort',
      userBlockAddSuccess: 'Blockering tillagd',
      userBlockAddFailure: 'Blockeringen kunde inte läggas till',
    },
    alert: {
      deleteBlockTitle: 'Ta bort blockering',
      deleteBlockText: 'Är du säker på att du vill ta bort blockeringen?',
    },
    emptyState: {
      title: 'Inga blockeringar',
      subtitle: 'Det finns för närvarande inga blockerade användare',
    },
  },
  societySettingsView: {
    title: 'Inställningar',
    feedSettings: {
      title: 'Alternativ för flödet',
      disablePostingTitle: 'Stäng av boendeinlägg och kommentarer',
      disablePostingDisclaimerText:
        'Boende kan då inte längre skapa eller kommentera boendeinlägg, men kan fortfarande kommentera inlägg från styrelsen och administratörer. Detta alternativ bör endast väljas i undantagsfall eftersom det hindrar era boende från att skapa värdefulla relationer.',
      marketplaceDisablePostingTitle:
        'Stäng av notis och inlägg för köp och sälj',
    },
    chatSettings: {
      title: 'Inställningar för chatt',
      disableOneOnOneTitle: 'Stäng av chatt mellan grannar',
      disableInterestsTitle: 'Stäng av gruppchatt-funktion',
      disableAskBoardTitle: 'Stäng av fråga styrelsen',
      disableAskBoardTitle_lgh: 'Stäng av fråga förvaltaren',
      chatAskBoardDisabledResidentMessageTitle: 'Meddelande till boende',
      chatAskBoardDisabledResidentMessageTitle_lgh: 'Meddelande till boende',
      chatAskBoardDisabledResidentMessagePlaceholder:
        'Vänligen kontakta styrelsen via mejl på info@...',
      chatAskBoardDisabledResidentMessagePlaceholder_lgh:
        'Vänligen kontakta styrelsen via mejl på info@...',
    },
    updateSettingsSuccess: 'Uppdaterade inställningarna',
    contactListUserInformationSetting: 'Inställning för boendelista',
    contactListUserInformation: 'Visa kontakuppgifter (epost och telefon)',
  },
  supportView: {
    title: 'Support',
  },
  societyWebsiteView: {
    title: 'Vår hemsida',
    subTitle:
      'Informationen ni anger här visas på er publika föreningshemsida. Det är ni som förening som ansvarar för innehållet.',
    subTitle_lgh:
      'Informationen ni anger här visas på er publika fastighetshemsida. Det är ni som fastighet som ansvarar för innehållet.',
    visitWebsite: 'Besök hemsidan',
    tabBar: {
      generalInformation: 'Namn och beskrivning',
      images: 'Bilder',
      documents: 'Dokument',
      questionsAndAnswers: 'Frågor och svar',
      contact: 'Kontakt',
    },
  },
  societyWebsiteGeneralInformation: {
    form: {
      displayName: 'Namn',
      description: 'Presentation',
    },
    flashMessage: {
      updateSuccess: 'Informationen om hemsidan uppdaterades',
      updateFailure: 'Informationen om hemsidan kunde inte uppdateras',
    },
  },
  societyWebsiteContact: {
    form: {
      recipientId: 'Styrelsemedlem',
      recipientId_lgh: 'Förvaltare',
      recipientLabel: 'Mottagare',
      addMore: 'Lägg till fler',
      copy: 'Kopia',
      copyTooltip:
        'Här lägger du till de mejladresser som ska få en kopia av meddelanden skickade från kontaktformuläret på hemsidan',
    },
    flashMessage: {
      updateSuccess: 'Kontakt uppdaterades',
      updateFailure: 'Kontakt kunde inte uppdateras',
    },
    confirmationModal: {
      removeEmailTitle: 'Radera mejladress',
      removeEmailText: 'Är du säker på att du vill radera mejladressen?',
    },
  },
  societyWebsiteQuestionsAndAnswers: {
    flashMessage: {
      updateSuccess: 'Frågor och svar uppdaterades',
      updateFailure: 'Frågor och svar kunde inte uppdateras',
    },
  },
  societyWebsiteDocuments: {
    addNewDocument: 'Ladda upp dokument',
    addNewFolder: 'Skapa ny mapp',
    emptyState: {
      title: 'Du har inget att läsa',
      emptyFolderSubtitle:
        'Just nu finns det inga dokument publicerade i "{{folderName}}".',
      noDocumentsSubtitle:
        'Just nu finns det inga mappar eller dokument publicerade.',
    },
  },
  societyWebsite: {
    showOnWebsite: 'Visa på hemsidan',
  },
  supportContact: {
    infoText: 'Har du en fråga eller synpunkt? Skicka ett meddelande!',
    form: {
      subject: 'Rubrik',
      subjectPlaceholder: 'Ange en kort rubrik för ditt ärende',
      message: 'Meddelande',
      messagePlaceholder: 'Beskriv ditt ärende',
      send: 'Skicka meddelande',
      whichPlatform: 'Vilken plattform använde du när problemet inträffade?',
    },
  },
  bostadsratterna: {
    bostadsratternaBenefitsView: {
      title: 'Medlemsförmåner',
      benefitsTitle: 'Medlemsförmåner',
      benefitsText:
        'Som medlem i Bostadsrätterna får du tillgång till ett omfattande utbud av medlemsförmåner, noggrant utformade för att förenkla och stärka arbetet för både styrelsen och medlemmarna i er bostadsrättsförening.​',
      benefitsText_lgh:
        'Som medlem i Bostadsrätterna får du tillgång till ett omfattande utbud av medlemsförmåner, noggrant utformade för att förenkla och stärka arbetet för både förvaltaren och medlemmarna i er bostadsrättsfastighet.​',
      insuranceTitle: 'Fastighetsförsäkring till förmånligt pris',
      insuranceText:
        'Vår fastighetsförsäkring, som är framtagen av Söderberg & Partners, har ett mer omfattande skydd än andra försäkringar på marknaden och gör att 9 av 10 föreningar får en bättre försäkring till ett lägre pris.',
      insuranceText_lgh:
        'Vår fastighetsförsäkring, som är framtagen av Söderberg & Partners, har ett mer omfattande skydd än andra försäkringar på marknaden och gör att 9 av 10 fastigheter får en bättre försäkring till ett lägre pris.',
    },
    bostadsratternaSchoolView: {
      title: 'Bostadsrättsskolan',
      coursesTitle: 'Kurser',
      coursesText:
        'I bostadsrättskolan erbjuder vi ett brett utbud av kurser för alla er som arbetar i styrelserna i era föreningar. Samtliga ingår i medlemskapet.',
      coursesText_lgh:
        'I bostadsrättskolan erbjuder vi ett brett utbud av kurser för alla er som arbetar i förvaltningen i era fastigheter. Samtliga ingår i medlemskapet.',
      seminarsTitle: 'Seminarier',
      seminarsText: 'Kortare utbildningar för ditt uppdrag i föreningen.',
      seminarsText_lgh: 'Kortare utbildningar för ditt uppdrag i fastigheten.',
      webAndVideoCoursesTitle: 'Webb- och videokurser',
      webAndVideoCoursesText:
        'Nya interaktiva webbkurser som gör det kul och enkelt att lära.',
    },
    bostadsratternaStatutesView: {
      title: 'Stadgemall',
      statutesTitle: 'Stadgemall',
      statutesText:
        'Som medlem har ni fri tillgång till vår stadgemall. Den kan laddas ner och antas i sin helhet, eller anpassas efter föreningens behov.',
      statutesText_lgh:
        'Som medlem har ni fri tillgång till vår stadgemall. Den kan laddas ner och antas i sin helhet, eller anpassas efter fastighetens behov.',
    },
    bostadsratternaGuidanceView: {
      title: 'Styrelserådgivning',
      guidanceText: 'Kostnadsfri rådgivning vardagar 09:00-16:30',
    },
    bostadsratternaFormsView: {
      title: 'Mallar & blanketter',
      formsTitle: 'Mallar & blanketter',
      formsText:
        'Som medlem i Bostadsrätterna får ni våra mallar och blanketter för avtal, ansökningar och annat som behövs i en förening (inloggning krävs).',
      formsText_lgh:
        'Som medlem i Bostadsrätterna får ni våra mallar och blanketter för avtal, ansökningar och annat som behövs i en fastighet (inloggning krävs).',
    },
  },
  samfalligheterna: {
    samfalligheternaSchoolView: {
      title: 'Utbildningar',
      description:
        'Det finns en mängd detaljerade regler för en samfällighetsförening: om medlemsavgifter, hur beslut ska fattas och vad en samfällighet får ägna sig åt. Har ni fått nya personer i styrelsen, eller är osäkra på vad som gäller, är det en bra idé att gå någon av våra utbildningar.',
      description_lgh:
        'Det finns en mängd detaljerade regler för en samfällighetsfastighet: om medlemsavgifter, hur beslut ska fattas och vad en samfällighet får ägna sig åt. Har ni fått nya personer i förvaltningen, eller är osäkra på vad som gäller, är det en bra idé att gå någon av våra utbildningar.',
      coursesTitle: 'Kurser',
      coursesText:
        'På våra utbildningar lär du dig allt du behöver veta för att sköta en samfällighetsförening (inloggning krävs).',
      coursesText_lgh:
        'På våra utbildningar lär du dig allt du behöver veta för att sköta en samfällighetsfastighet (inloggning krävs).',
    },
    samfalligheternaBenefitsView: {
      title: 'Medlemsförmåner',
      description:
        'Vårt mål är att styrelsearbetet i din förening ska vara så smidigt och glädjefullt som möjligt. I kraft av vår storlek har vi fixat bra rabatter och förmåner hos några av Sveriges mest välkända företag. Så att ni kommer undan lite billigare när ni ska köpa något som hör föreningen till.',
      description_lgh:
        'Vårt mål är att förvaltningsarbetet i din fastighet ska vara så smidigt och glädjefullt som möjligt. I kraft av vår storlek har vi fixat bra rabatter och förmåner hos några av Sveriges mest välkända företag. Så att ni kommer undan lite billigare när ni ska köpa något som hör fastigheten till.',
      benefitsTitle: 'Förmåner och rabatter',
      benefitsText:
        'Exklusiva erbjudanden till föreningar med trygghetsavtal (inloggning krävs).',
      benefitsText_lgh:
        'Exklusiva erbjudanden till fastigheter med trygghetsavtal (inloggning krävs).',
    },
    samfalligheternaGuidanceView: {
      title: 'Styrelserådgivning',
      guidanceDescription:
        'Få kostnadsfri rådgivning hos våra jurister, lantmätare, byggnadstekniker, geotekniker, energi-, vvs- och trädgårdsrådgivare.',
      guidanceText:
        'Kostnadsfri rådgivning 08:30-16:30 måndag-torsdag, 08:30-14:00 fredag',
    },
  },
  managementPartnerContactForm: {
    writeQuestionTitle: 'Skriv din fråga',
    writeQuestionPlaceholder: 'Meddelande',
    sendQuestionTitle: 'Skicka fråga',
    shareInformationTitle: 'Dela information',
    shareInformationTooltipBostadsratterna:
      'Kontaktuppgifter till dig och din förening delas med bostadsrätterna',
    shareInformationTooltipBostadsratterna_lgh:
      'Kontaktuppgifter till dig och din fastighet delas med bostadsrätterna',
    shareInformationTooltipSamfalligheterna:
      'Kontaktuppgifter till dig och din förening delas med samfälligheterna',
    shareInformationTooltipSamfalligheterna_lgh:
      'Kontaktuppgifter till dig och din fastighet delas med samfälligheterna',
    helperText: 'Vår målsättning är att svara inom 24 timmar.',
    messageSendFailure: 'Meddelandet kunde inte skickas',
    messageSendSuccess: 'Meddelandet har skickats',
  },
  scheduledPosts: {
    bannerTitleSingle: '1 schemalagt inlägg',
    bannerTitlePlural: '{{total}} schemalagda inlägg',
    nextPublish: 'Nästa publiceras {{date}}',
    publishInfo: 'kl. {{time}} · {{relative}}',
    edit: 'Redigera',
    form: {
      label: 'Schemalägg publicering',
      helpText:
        'Inlägget visas i flödet från den valda tidpunkten. Lämna tomt för att publicera direkt.',
      scheduleAction: 'Schemalägg',
    },
    deleteTitle: 'Ta bort schemalagt inlägg',
    deleteText: 'Inlägget är inte publicerat ännu. Vill du ta bort det?',
    flashMessage: {
      scheduleSuccess: 'Inlägget är schemalagt',
      rescheduleSuccess: 'Publiceringstiden är ändrad',
      publishNowSuccess: 'Inlägget publiceras nu',
    },
  },
  feedView: {
    title: 'Flöde',
    newPost: 'Skriv ett inlägg...',
    modalTitle: 'Nytt inlägg',
    create: 'Skapa',
    filterFeed: {
      title: 'Filtrera inlägg',
      modalTitle: 'Filtrera',
      subtitle: 'Välj vad du vill se i ditt flöde',
      primaryButtonTitle: 'Bekräfta',
      postsFilterTitle: 'Inlägg',
      societyFilterTitle: 'Föreningar',
      societyFilterTitle_lgh: 'Fastigheter',
      postsFilterAllOptionValue: 'Visa alla',
      postsFilterBoardOptionValue: 'Inlägg från styrelsen',
      postsFilterBoardOptionValue_lgh: 'Inlägg från förvaltaren',
      postsFilterNeighboursOptionValue: 'Inlägg från grannar',
      postsFilterImportantOptionValue: 'Viktiga meddelanden',
      societiesFilterTitle: 'Filtrera föreningar',
      societiesFilterTitle_lgh: 'Filtrera fastigheter',
      societiesFilterAllOptionValue: 'Visa alla',
    },
    emptyFilter: {
      title: 'Inga inlägg hittades',
      subtitle: 'Ändra dina filter eller skapa ett nytt inlägg',
    },
    emptyState: {
      noSociety: {
        title: 'Du är inte medlem i en förening',
        title_lgh: 'Du är inte medlem i en fastighet',
        subtitle: 'Vad vill du göra?',
        buttonTitle: 'Gå med i en befintlig förening',
        buttonTitle_lgh: 'Gå med i en befintlig fastighet',
        createSocietyButton: 'Skapa en ny förening',
        createSocietyButton_lgh: 'Skapa en ny fastighet',
      },
      pendingRequest: {
        title: 'Inväntar bekräftelse från styrelsen',
        subtitle:
          'Här kommer du kunna gilla, kommentera och skapa inlägg samt ta del av viktig information från styrelsen.',
        buttonTitle: 'Hitta förening',
        buttonTitle_lgh: 'Hitta fastighet',
      },
      emptyFeed: {
        title: 'Det finns inga inlägg i flödet',
        subtitle:
          'Här kommer du kunna gilla, kommentera och skapa inlägg samt ta del av viktig information från styrelsen.',
        buttonTitle: 'Skapa inlägg',
      },
    },
    formatText: {
      title: 'Ange nedanstående för att formatera text',
      label: 'Textformatering',
      bold: 'Fetstil',
      italic: 'Kursiv',
      header: 'Rubrik',
      bulletPoints: 'Punktlista',
      list: 'Lista',
      horizontalLine: 'Horisontell linje',
    },
  },
  userView: {
    dateTitle: 'Medlem sedan',
    dateTitle_lgh: 'Hyresgäst sedan',
    interestsTitle: 'Intressen',
    educationTitle: 'Utbildning',
    occupationTitle: 'Arbete',
    presentationTitle: 'Om {{name}}',
  },
  postView: {
    errorView: {
      removed: {
        title: 'Inlägget är borttaget',
        subtitle: 'Klicka på knappen ovan för att återgå till flödet.',
      },
    },
    print: {
      published: 'Publicerat {{date}}',
      content: 'Innehåll',
      nothingSelected: 'Välj minst en del att skriva ut.',
      commentsLoading: 'Kommentarerna laddas…',
      commentsFailed: 'Kommentarerna kunde inte laddas.',
      sections: {
        header: 'Namn och logga',
        important: 'Viktigt meddelande',
        author: 'Skribent',
        date: 'Datum',
        text: 'Text',
        media: 'Bilder',
        events: 'Händelser',
        polls: 'Omröstningar',
        attachments: 'Förmåner, annonser, kontakter och faciliteter',
        comments: 'Kommentarer',
      },
      video: 'Video – se inlägget i Boappa',
      cancelled: 'Inställd',
    },
  },
  post: {
    important: 'Viktigt meddelande',
    importantMobile: 'Viktigt',
    pinned: 'Fäst inlägg',
    showMoreComments: 'Visa fler kommentarer',
    showEarlierComments: 'Visa tidigare kommentarer',
    commentUnavailable: 'Kommentaren finns inte längre.',
    showDiscussion: 'Visa kommentarerna',
    peopleEmpty: 'Ingen att visa.',
    commentInputPlaceholder: 'Skriv en kommentar...',
    editedPrefix: 'Redigerat',
    event: {
      prefix: 'Händelse',
      allDay: 'Heldag',
      goToEvent: 'Gå till händelse',
      addToCalendar: 'Lägg till i kalender',
    },
    alert: {
      postDeleteTitle: 'Radera inlägg',
      postDeleteText:
        'Är du säker på att du vill radera inlägget? Denna handling går ej att ångra och inlägget försvinner för samtliga användare i föreningen.',
      postDeleteText_lgh:
        'Är du säker på att du vill radera inlägget? Denna handling går ej att ångra och inlägget försvinner för samtliga användare i fastigheten.',
      commentDeleteTitle: 'Radera kommentar',
      commentDeleteText: 'Är du säker på att du vill radera kommentaren?',
    },
    flashMessage: {
      deletePostSuccess: 'Inlägg raderat',
      deletePostFailure: 'Inlägget kunde inte raderas',
      pinLimitReached: 'Du kan bara fästa {{ max }} inlägg',
      deleteCommentSuccess: 'Kommentar raderad',
      deleteCommentFailure: 'Kommentaren kunde inte raderas',
    },
    newMarketPlaceItemText: 'Ny annons i köp & sälj',
    newFacilityText: 'En ny facilitet har lagts upp',
    newContactText: 'En ny kontakt har lagts till',
    newLocalOfferText: 'En ny förmån har lagts till',
    tooltip: {
      visibility: {
        base: 'Inlägget visas för',
        admins: 'administratörer',
        board: 'styrelsen',
        board_lgh: 'förvaltaren',
        groups: 'grupperna',
      },
    },
    seenBy: 'Läst av',
  },
  previewPost: {
    title: 'Förhandsgranska inlägg',
    preview: 'Förhandsgranska',
  },
  pendingRequest: {
    title: 'Toppen!',
    subtitle:
      'Du får tillgång till föreningen så snart styrelsen godkänner uppgifterna.',
    subtitle_lgh:
      'Du får tillgång till fastigheten så snart förvaltaren godkänner uppgifterna.',
    titleAdvice: 'Tips: Du kan redan nu kolla in webbappen i förväg.',
    whatHappensNextTitle: 'Vad sker härnäst?',
    notificationText:
      'När du blir godkänd får du både en notis i webbappen och ett mail. \nFölj instruktionerna i mailet eller öppna webbappen och börja boappa!',
    assignmentText: 'Om du inte blivit godkänd - kontakta din styrelse.',
    checkOutTheApp: 'Kolla in webbappen!',
  },
  requestJoinSocietyForm: {
    sendRequest: 'Skicka förfrågan',
    title: 'Ansök om medlemskap i föreningen',
    title_lgh: 'Ansök om medlemskap i fastigheten',
    title_samf: 'Ansök om medlemskap i föreningen',
    flashMessage: {
      sendRequestSuccess: 'Förfrågan skickas',
      sendRequestFailure: 'Förfrågan kunde inte skickas',
    },
    tooltip: {
      unit: 'De 4 första siffrorna i ditt lägenhetsnummer är angett av Lantmäteriet \n\nStår siffrorna inom parentes ( ) har din förening angett numret',
      unit_lgh:
        'De 4 första siffrorna i ditt lägenhetsnummer är angett av Lantmäteriet \n\nStår siffrorna inom parentes ( ) har din fastighet angett numret',
      role: 'Medlem: Du som äger bostadsrätten och är därmed medlem i föreningen \n\nInneboende: Om du är exempelvis sambo, partner, vän, inneboende, barn till ägaren av lägenheten. \n\nHyresgäst: Du hyr bostadsrätten i andra hand. \n\nAnhörig: Person som representerar medlemmen.',
      role_lgh:
        'Medlem: Du som äger bostadsrätten och är därmed medlem i fastigheten \n\nInneboende: Om du är exempelvis sambo, partner, vän, inneboende, barn till ägaren av lägenheten. \n\nHyresgäst: Du hyr bostadsrätten i andra hand. \n\nAnhörig: Person som representerar medlemmen.',
    },
  },
  inactiveSociety: {
    title: 'Föreningen är inte aktiverad',
    title_lgh: 'Fastigheten är inte aktiverad',
    subtitle:
      'För att aktivera föreningen behöver du vara styrelseledamot. Du kan gå med i föreningen som medlem för att testa men du kommer då inte ha tillgång till all funktionalitet i appen.',
    subtitle_lgh:
      'För att aktivera fastigheten behöver du vara förvaltare. Du kan gå med i fastigheten som medlem för att testa men du kommer då inte ha tillgång till all funktionalitet i appen.',
    tabs: {
      board: 'Styrelsemedlem',
      member: 'Medlem',
    },
    board: {
      boardTitle: 'Alternativ 2: Gå med som styrelsemedlem',
      boardSubtitle:
        'Sitter du i styrelsen men önskar att ej bli administratör kan du välja att enbart gå med i föreningen. Du kommer inte ha tillgång till all funktionalitet i appen.',
      boardSubtitle_lgh:
        'Är du förvaltare men önskar att ej bli administratör kan du välja att enbart gå med i fastigheten. Du kommer inte ha tillgång till all funktionalitet i appen.',
      adminTitle: 'Alternativ 1: Gå med som administratör',
      adminSubtitle:
        'Aktivera din förening och få full funktionalitet i appen. Du tilldelas då rollen huvudadministratör för din förening och du kan därefter utse fler administratörer.',
      adminSubtitle_lgh:
        'Aktivera din fastighet och få full funktionalitet i appen. Du tilldelas då rollen huvudadministratör för din fastighet och du kan därefter utse fler administratörer.',
    },
    member: {
      title: 'Gå med i förening',
      title_lgh: 'Gå med i fastighet',
      subtitle:
        'Föreningen är ännu inte aktiverad men det är fritt fram att gå med i den oavsett om du är boende eller styrelsemedlem.',
      subtitle_lgh:
        'Fastigheten är ännu inte aktiverad men det är fritt fram att gå med i den oavsett om du är boende eller förvaltare.',
    },
    flashMessage: {
      joinSocietySuccess: 'Gick med i förening',
      joinSocietySuccess_lgh: 'Gick med i fastighet',
      joinSocietyFailure: 'Kunde inte gå med i förening',
      joinSocietyFailure_lgh: 'Kunde inte gå med i fastighet',
      activateSocietyFailure: 'Kunde inte aktivera förening',
      activateSocietyFailure_lgh: 'Kunde inte aktivera fastighet',
      activateSocietySuccess: 'Förening aktiverades',
      activateSocietySuccess_lgh: 'Fastighet aktiverades',
    },
  },
  findSociety: {
    labels: {
      newSociety: 'Ny förening',
      newSociety_lgh: 'Ny fastighet',
      userMemberOfSociety: 'Inloggad',
      hasPendingRequest: 'Förfrågan skickad',
      search: 'Sök på namn, adress eller org.nr',
      brfDeveloper: 'Bostadsutvecklare?',
      cannotFindSociety: 'Hittar du inte din förening?',
      cannotFindSociety_lgh: 'Hittar du inte din fastighet?',
    },
  },
  createSocietyView: {
    title: 'Skapa ny förening',
    title_lgh: 'Skapa ny fastighet',
    tabs: {
      housingCooperative: 'Styrelsen i min brf',
      homeownersAssociation: 'Styrelsen i min samfällighet',
      realEstateDeveloper: 'Bostadsutvecklare',
    },
  },
  createSocietyForm: {
    createSocietyTitle: 'Skapa förening',
    realEstateDeveloperTitle: 'Skapa ny förening',
    neighbourhoodTitle: 'Grannskap',
    samfTitle: 'Skapa er samfällighetsförening',
    brfTitle: 'Skapa er bostadsrättsförening',
    societyOrProjectTitle: 'Förening/projekt',
    societyNameTooltipTitle: 'Standardförkortningar',
    societyNameTooltipText:
      'Anläggningssamfällighet = As\nBostadsförening = Bf\nBostadsrättsförening = Brf\nEkonomisk förening = Ek för\nGemensamhetsanläggning = Ga\n_samfällighetsförening = Samf\nUtan personligt ansvar = Upa\nVägsamfällighet = Vägsam\nVägförening = Vägf',
    addressStreet: 'Adress',
    headers: {
      realEstateDeveloper: 'Bostadsutvecklare',
      society: 'Förening/projekt',
      society_lgh: 'Fastighet/projekt',
      societyAlreadyExists: 'Din förening finns redan i Boappa',
    },
    labels: {
      numberOfBillingUnits: 'Antal lägenheter',
      numberOfBillingUnits_samf: 'Antal fastigheter',
      societyName: 'Föreningens namn',
    },
    errors: {
      societyAlreadyActivated: 'Föreningen är redan aktiverad',
    },
    modal: {
      title: 'Din förening finns redan i Boappa',
      title_lgh: 'Din fastighet finns redan i Boappa',
      organisationNumberShort: 'Org nr',
      alreadyMemberOfSociety: 'Du är redan medlem i denna förening.',
      societyExistsButInactive: 'Föreningen finns redan men är inaktiv',
    },
    flashMessage: {
      createSocietySuccess: 'Föreningen har skapats',
      createSocietyFailure: 'Föreningen kunde inte skapas',
    },
  },
  findSocietyConfirmActivationForm: {
    roleTitle: 'Vad är din roll i styrelsen?',
    inviteBoardMembersTitle:
      'Bjud in dina styrelsekollegor för att testa Boappa tillsammans (valfritt)',
    numberOfApartmentsTitle: 'Totala antalet lägenheter',
    numberOfApartmentsTitle_samf: 'Totala antalet fastigheter',
    numberOfApartmentsDescription:
      'Uppge det totala antalet lägenheter som ingår i föreningen. Inkludera även kommersiella och uthyrda lägenheter.',
    numberOfApartmentsDescription_samf:
      'Uppge det totala antalet fastigheter som ingår i föreningen. Inkludera även kommersiella och uthyrda fastigheter.',
    enterEmail: 'Ange mejladress',
    flashMessage: {
      invitesSentSuccess: 'Inbjudningar skickade',
    },
  },
  findSocietyConfirmActivationView: {
    title: 'Snart klart!',
    subtitle:
      'Vi behöver kompletterande information från dig innan du kan börja boappa.',
  },
  activatedSocietyConfirmationView: {
    title: 'Föreningen är aktiverad!',
    title_lgh: 'Fastigheten är aktiverad!',
    subtitle:
      'Du är nu registrerad som huvudaministratör och kan bjuda in styrelsemedlemmarna för att testa Boappa.',
    buttonTitle: 'Börja boappa!',
  },
  newSocietyView: {
    title: 'Ny förening',
    title_lgh: 'Ny fastighet',
  },
  findSocietyView: {
    title: 'Hitta din förening',
    title_lgh: 'Hitta din fastighet',
    header: 'Så här enkelt kan också du komma igång och boappa i din förening.',
    header_lgh:
      'Så här enkelt kan också du komma igång och boappa i din fastighet.',
    description:
      'Med Boappa kan du och dina grannar enkelt få information om vad som händer i föreningen och snabbt komma i kontakt med både styrelsen och grannar. Boappa finns både som app och webb och det är enkelt att komma-igång.',
    description_lgh:
      'Med Boappa kan du och dina grannar enkelt få information om vad som händer i fastigheten och snabbt komma i kontakt med både förvaltaren och grannar. Boappa finns både som app och webb och det är enkelt att komma-igång.',
    description2:
      'Om du fått en inbjudan via mail av föreningen att gå med då behöver du bara bekräfta inbjudan efter att du loggat in i Boappa. I annat fall kan du ansöka om att gå med i föreningen enligt nedan.',
    description2_lgh:
      'Om du fått en inbjudan via mail av fastigheten att gå med då behöver du bara bekräfta inbjudan efter att du loggat in i Boappa. I annat fall kan du ansöka om att gå med i fastigheten enligt nedan.',
    description3: 'Börja med att söka upp föreningen:',
    description3_lgh: 'Börja med att söka upp fastigheten:',
  },
  findFriendsView: {
    title: 'Lär känna dina grannar',
    description:
      'Hitta en löparkompis i porten bredvid eller få sällskap på barnvagnspromenaderna av grannen längre ned på gatan.',
    extra:
      'Lägg in dina intressen i din profil och se vilka grannar som delar dem.',
    updateYourProfile: 'Uppdatera din profil',
    errorView: {
      noMatches: {
        title: 'Hittade inga matchingar',
        subtitle:
          'Uppdatera din profil och ta reda på vem som delar samma intressen som dig',
      },
    },
  },
  questionsAndAnswersView: {
    title: 'Frågor & Svar',
    emptyState: {
      title: 'Det finns inga frågor och svar',
      subtitle: 'Styrelsen har inte lagt upp några frågor och svar ännu.',
      subtitle_lgh: 'Förvaltaren har inte lagt upp några frågor och svar ännu.',
      noQuestionsAndAnswersText:
        'Det finns inga frågor och svar för denna sektion.',
    },
  },
  societyCalendarListView: {
    title: 'Kalender',
    buttons: {
      create: 'Ny kalenderhändelse',
    },
    activeTabBar: {
      previousTitle: 'Tidigare',
      upcomingTitle: 'Kommande',
    },
    noCalendarEvents: {
      title: 'Luta dig tillbaka, inget inbokat i kalendern.',
      subtitle: 'I dagsläget finns inga kalenderhändelser att visa.',
    },
  },
  eventDetailView: {
    errors: {
      notFound: {
        title: 'Kalenderhändelsen kunde inte hittas',
        subtitle: 'Du försökte gå in på en kalenderhändelse som inte finns.',
      },
    },
    tabBar: {
      information: 'Information',
      attendance: 'Deltagarlista',
    },
    headers: {
      date: 'Datum',
      attendants: 'Deltagare',
    },
    attendance: {
      titles: {
        attending: 'Kommer',
        notAttending: 'Kan inte komma',
        noReply: 'Inget svar',
      },
      list: 'Deltagarlista',
    },
    buttons: {
      seeAllAttendants: 'Se alla deltagare',
    },
  },
  createUpdateEvent: {
    addToCalendar: 'Lägg till i kalender',
    modal: {
      createTitle: 'Skapa händelse',
      editTitle: 'Redigera händelse',
    },
    confirmationModal: {
      deleteTitle: 'Radera händelse',
      deleteDescription: 'Är du säker på att du vill radera händelsen?',
    },
    form: {
      labels: {
        title: 'Aktivitet',
        location: 'Plats',
        isAllDay: 'Heldag',
        startDate: 'Starttid',
        endDate: 'Sluttid',
        startDay: 'Startdag',
        endDay: 'Slutdag',
        description: 'Beskrivning',
        attendanceEnabled: 'Deltagarlista',
        allowComments: 'Tillåt kommentarer',
      },
    },
    flashMessage: {
      updateEventSuccess: 'Händelse uppdaterad',
      updateEventFailure: 'Händelsen kunde inte uppdateras',
      createEventSuccess: 'Händelse skapad',
      createEventFailure: 'Händelsen kunde inte skapas',
      deleteEventSuccess: 'Händelse raderad',
      deleteEventFailure: 'Händelsen kunde inte raderas',
    },
  },
  facilitiesView: {
    title: 'Bokningar & Faciliteter',
    tabBar: {
      newBooking: 'Ny bokning',
      myBookings: 'Mina bokningar',
    },
    emptyState: {
      noFacilitiesTitle: 'Det finns inget att boka',
      noFacilitiesSubtitle:
        'Styrelsen har inte lagt in några gemensamma faciliteter för digital bokning. Har du förslag på ytor eller föremål som kan bokas får du gärna tipsa styrelsen genom att skapa ett ärende under “Ärenden”.',
      noFacilitiesSubtitle_lgh:
        'Förvaltaren har inte lagt in några gemensamma faciliteter för digital bokning. Har du förslag på ytor eller föremål som kan bokas får du gärna tipsa förvaltaren genom att skapa ett ärende under “Ärenden”.',
      noBookingsTitle: 'Du har inga bokningar',
      noBookingsSubtitle:
        'Gå till “Ny bokning” och välj den facilitet du vill boka. Därefter kommer din bokning dyka upp här.',
    },
    buttons: {
      create: 'Skapa facilitet',
    },
  },
  createUpdateFacility: {
    editFacilityTitle: 'Redigera facilitet',
    createFacilityTitle: 'Skapa facilitet',
    form: {
      labels: {
        booking: 'Bokningsbar',
        coverPhoto: 'Omslagsbild',
        name: 'Titel',
        description: 'Beskrivning',
        bookingGranularity: 'Bokningsintervall',
        rules: 'Bokningsregler',
        bookableFrom: 'Bokningsbar från',
        bookableTo: 'Bokningsbar till',
        bookableUntilFurtherNotice: 'Tillsvidare',
        visibility: 'Synlighet',
        bookingMessage: 'Bokningsmeddelande',
        notificationEmails: 'Notifiering vid bokning och avbokning',
        blockedDates: 'Blockerade datum',
        weeklySchedule: 'Veckoschema',
      },
      helperText: {
        coverPhoto: 'Rekommenderad minsta bildstorlek: 1280x800 pixlar',
      },
      headers: {
        general: 'Allmänt',
        details: 'Bokningsdetaljer',
        notificationSettings: 'Notifikationsinställningar',
        recipient: 'Mottagare',
        cc: 'Kopia',
        day: 'Dag',
        startTime: 'Start',
        endTime: 'Slut',
        active: 'Aktiv',
      },
      warnings: {
        bookingGranularity: {
          cantEdit:
            'Du kan inte ändra schemat när faciliteten har aktiva bokningar.',
        },
      },
      options: {
        visibility: {
          all: 'Alla',
          adminOnly: 'Endast administratörer',
        },
        bookingGranularity: {
          oneHour: 'En timme',
          twoHours: 'Två timmar',
          threeHours: 'Tre timmar',
          fourHours: 'Fyra timmar',
          fiveHours: 'Fem timmar',
          sixHours: 'Sex timmar',
          sevenHours: 'Sju timmar',
          eightHours: 'Åtta timmar',
          fullDay: 'Heldag',
        },
        rules: {
          oneActive: 'En aktiv bokning',
          twoActive: 'Två aktiva bokningar',
          threeActive: 'Tre aktiva bokningar',
          fourActive: 'Fyra aktiva bokningar',
          fiveActive: 'Fem aktiva bokningar',
          unlimited: 'Fritt antal bokningar',
        },
      },
    },
    flashMessage: {
      updateFacilityFailure: 'Faciliteten kunde inte uppdateras',
      updateFacilitySuccess: 'Faciliteten har uppdaterats',
      createFacilityFailure: 'Faciliteten kunde inte skapas',
      createFacilitySuccess: 'Faciliteten har skapats',
      deleteFacilitySuccess: 'Facilitet borttagen',
      deleteFacilityFailure: 'Facilitet kunde inte tas bort',
    },
    confirmationModal: {
      deleteTitle: 'Radera facilitet',
      deleteDescription: 'Är du säker på att du vill radera faciliteten?',
    },
    weeklyScheduleDescription:
      'Tryck på siffrorna i schemat, för att ändra start- eller sluttid. För att ställa in heldagsbokning, sätt upp tiderna 00:00 - 00:00.',
  },
  facilityView: {
    tabBar: {
      calendar: 'Kalender',
      information: 'Information',
      bookings: 'Bokningar',
    },
    calendar: {
      sections: {
        chooseUnit: {
          title: 'Vilken lägenhet vill boka?',
          title_samf: 'Vilken fastighet vill boka?',
        },
        chooseDate: {
          title: 'Välj datum',
        },
        chooseSlot: {
          title: 'Välj tid',
        },
        bookingMessage: {
          title: 'Bokningsmeddelande',
        },
        yourBooking: {
          title: 'Dina bokningar',
        },
      },
      fullDay: 'Heldag',
      booked: 'Bokad',
      alert: {
        unitMaxNumberBookings:
          'Du har uppnått maximalt antal aktiva bokningar för facilititen.',
        noTimeSlots: 'Det finns inga lediga tider för den valda dagen.',
        noUnit: 'För att göra en bokning måste du vara tilldelad en lägenhet.',
        noUnit_samf:
          'För att göra en bokning måste du vara tilldelad en fastighet.',
        bookingDisabledText: 'Faciliteten går inte att boka.',
      },
      flashMessage: {
        createBookingSuccess: 'Bokad',
        createBookingFailure: 'Bokningen kunde inte skapas',
      },
    },
    information: {
      sections: {
        description: {
          title: 'Beskrivning',
          noDescriptionText: 'Faciliteten har ingen beskrivning.',
        },
      },
    },
    bookings: {
      buttons: {
        previousMonth: 'Föregående månad',
        nextMonth: 'Nästa månad',
        deleteBooking: 'Avboka tid',
      },
      errorView: {
        noBookings: {
          title: 'Det finns inga bokningar',
          subtitle: 'Gå till fliken "Kalender" för att boka denna facilitet.',
        },
      },
      alert: {
        deleteTitle: 'Avboka tid',
        deleteDescription: 'Är du säker på att du vill ta bort bokningen?',
        deleteOtherUserBookingDescription:
          'Är du säker på att du vill ta bort bokningen gjord av {{ name }}?',
        deleteBookingButtonLabel: 'Avboka',
      },
      flashMessage: {
        deleteBookingFailure: 'Tiden kunde inte avbokas. Tiden kan ha passerat',
        deleteBookingSuccess: 'Avbokad',
      },
    },
  },
  houseRulesView: {
    title: 'Trivselregler',
    emptyState: {
      title: 'Det finns inga trivselregler',
      subtitle: 'När styrelsen skapar nya regler så dyker de upp här.',
      subtitle_lgh: 'När förvaltaren skapar nya regler så dyker de upp här.',
    },
  },
  societyInviteModal: {
    title: 'Vi har hittat ditt hem!',
    buttons: {
      accept: 'Ja, det stämmer!',
      deny: 'Neka inbjudan',
    },
    flashMessage: {
      acceptPreApprovedSuccess: 'Föreningen har lagts till',
      acceptPreApprovedFailure: 'Föreningen kunde inte läggas till',
      denyPreApprovedSuccess: 'Inbjudan har nekats',
      denyPreApprovedFailure: 'Inbjudan kunde inte nekas',
    },
  },
  ticket: {
    status: {
      open: 'Öppen',
      closed: 'Stängd',
    },
    closedBanner: {
      title: 'Detta ärende är stängt',
      subtitle:
        'Du kan fortfarande läsa konversationen, men inga nya meddelanden kan skickas.',
    },
    variant: {
      report: 'Felanmälan',
      question: 'Fråga',
    },
    error: {
      notFound: 'Kunde inte hitta ärendet',
    },
  },
  ticketListView: {
    empty: {
      title: 'Inga ärenden',
      subtitle_open:
        'När det kommer in ett nytt ärende kommer ärendet synas här',
      subtitle_all: 'Här kommer du kunna se både öppna och stängda ärenden',
    },
    sender: {
      me: 'Du',
      board: 'Styrelsen',
    },
    message: {
      sentImage: 'skickade en bild',
      sentFile: 'skickade en fil',
    },
  },
  ticketNav: {
    my: 'Mina',
    create: 'Skapa nytt ärende',
    open: 'Öppna',
    all: 'Alla',
    closed: 'Stängda ärenden',
  },
  ticketListViewBoard: {
    empty: {
      title: 'Inga ärenden',
      subtitle_my:
        'När du blir tilldelad ett ärende kommer ärendet dyka upp här',
      subtitle_open:
        'När det kommer in ett nytt ärende kommer ärendet synas här',
      subtitle_all: 'Här kommer ni kunna se både öppna och stängda ärenden',
    },
    sender: {
      me: 'Du',
      deletedUser: 'Borttagen användare',
    },
    message: {
      sentImage: 'skickade en bild',
      sentFile: 'skickade en fil',
    },
  },
  ticketBoardView: {
    title: 'Ärendehantering',
    disabled: {
      title: 'Ärenden - Styrelsefråga är ej aktiverad för medlemmarna',
      title_report: 'Ärenden - Felanmälan är ej aktiverad för medlemmarna',
      subtitle: 'Aktivera den under funktioner',
    },
  },
  ticketView: {
    title: 'Ärenden',
    form: {
      title: 'Nytt ärende',
      tabs: {
        question: 'Styrelsefråga',
        report: 'Felanmälan',
      },
      labels: {
        customer: 'Mottagare',
        title: 'Rubrik',
        description: 'Beskrivning',
        images: 'Bilder',
        documents: 'Dokument',
        space: 'Var har felet uppstått?',
      },
      space: {
        apartment: 'Lägenheten',
        building: 'Byggnaden',
        surroundings: 'Området',
        commonAreas: 'Gemensamma utrymmen',
        other: 'Annat',
      },
    },
    attachments: {
      images: 'Bilder',
      documents: 'Dokument',
    },
    flashMessage: {
      createTicketSuccess: 'Ärendet skapades',
      createTicketFailure: 'Ärendet kunde inte skapas',
    },
  },
  ticketDetailView: {
    title: 'Ärende',
    links: {
      chat: 'Chatt',
      documents: 'Dokument',
      images: 'Bilder',
    },
  },
  ticketDetailViewBoard: {
    title: 'Ärende',
    links: {
      chat: 'Chatt',
      documents: 'Dokument',
      images: 'Bilder',
      manage: 'Hantera',
    },
  },
  ticketSidebar: {
    images: 'Bilder',
    documents: 'Dokument',
    imagesTitle: 'Bilder',
    documentsTitle: 'Dokument',
    emptyImagesTitle: 'Inga bilder på ärendet',
    emptyDocumentsTitle: 'Inga dokument på ärendet',
    titleLabel: 'Rubrik',
    descriptionLabel: 'Beskrivning',
    createdAtLabel: 'Skapades',
    variantLabel: 'Ärendetyp',
    spaceLabel: 'Var har felet uppstått?',
  },
  ticketBoardSidebar: {
    images: 'Bilder',
    documents: 'Dokument',
    imagesTitle: 'Bilder',
    documentsTitle: 'Dokument',
    emptyImagesTitle: 'Inga bilder på ärendet',
    emptyDocumentsTitle: 'Inga dokument på ärendet',
    titleLabel: 'Rubrik',
    customerLabel: 'Boende',
    descriptionLabel: 'Beskrivning',
    createdByLabel: 'Skapad av',
    createdAtLabel: 'Skapades',
    assignLabel: 'Tilldela ärende',
    unassigned: 'Ingen tilldelad',
    status: {
      close: 'Avsluta ärende',
      open: 'Öppna ärende',
    },
    variant: {
      label: 'Typ av ärende',
      save: 'Spara',
      option: {
        question: 'Fråga',
        report: 'Felanmälan',
      },
    },
    forwardTicket: {
      button: 'Skicka till extern e-post',
      subjectPrefix: 'Felanmälan: ',
      subjectPrefix_question: 'Fråga: ',
      bodyArea: 'Var har felet uppstått?',
      bodyIntro: 'Felanmälan skapad {{date}} i Boappa.',
      bodyIntro_question: 'Fråga skapad {{date}} i Boappa.',
      labelSociety: 'Förening',
      labelResident: 'Boende',
      labelAddress: 'Adress',
      labelUnit: 'Lgh-nr',
      labelEmail: 'Mejl',
      labelMobile: 'Mobilnr',
      labelTitle: 'Rubrik',
      labelDescription: 'Beskrivning',
      greeting: 'Hälsningar',
      signature: 'Styrelsen i {{societyName}}',
      missing: '-',
    },
  },
  reportProblemView: {
    title: 'Felanmälan',
    form: {
      labels: {
        title: 'Rubrik',
        space: 'Var har felet uppstått?',
        message: 'Beskriv ditt ärende',
        images: 'Bilder',
      },
    },
    flashMessage: {
      createReportSuccess: 'Felanmälan skickad',
      createReportFailure: 'Felanmälan kunde inte skickas',
    },
    helperTexts: {
      contactInformation: 'Dina kontaktuppgifter bifogas automatiskt.',
    },
    errorView: {
      title: 'Epost saknas för felanmälan',
      subtitle: 'Ange en epost för att aktivera felanmälan',
    },
  },
  reportProblemSettings: {
    modal: {
      title: 'Inställningar för felanmälan',
    },
    form: {
      headers: {
        recipient: 'Mottagare',
        cc: 'Kopia',
      },
    },
  },
  localOffersView: {
    title: 'Förmåner',
    emptyState: {
      title: 'Inga förmåner',
      subtitle: 'Föreningen har ännu inte lagt till några förmåner.',
      subtitle_lgh: 'Förvaltaren har ännu inte lagt till några förmåner.',
    },
    modal: {
      create: 'Skapa ny förmån',
      update: 'Uppdatera förmån',
    },
    form: {
      labels: {
        benefit: 'Förmån',
        body: 'Beskrivning',
        companyName: 'Företagsnamn',
      },
      placeholders: {
        discount: '20% rabatt',
      },
      headers: {
        contactDetails: 'Kontaktuppgifter',
      },
    },
    flashMessage: {
      createLocalOfferSuccess: 'Förmån skapad',
      createLocalOfferFailure: 'Förmånen kunde inte skapas',
    },
  },
  localOfferView: {
    title: 'Förmån',
    confirmationModal: {
      deleteTitle: 'Radera förmån',
      deleteDescription: 'Är du säker på att du vill radera förmånen?',
    },
    errors: {
      notFound: {
        title: 'Förmånen kunde inte hittas',
        subtitle: 'Du försökte gå in på en förmån som inte finns.',
      },
    },
    flashMessage: {
      updateLocalOfferSuccess: 'Förmån uppdaterad',
      updateLocalOfferFailure: 'Förmånen kunde inte uppdateras',
      deleteLocalOfferSuccess: 'Förmån raderad',
      deleteLocalOfferFailure: 'Förmånen kunde inte raderas',
    },
  },
  marketplaceDetailView: {
    labels: {
      published: 'Publicerad',
      createdBy: 'Upplagd av',
    },
    confirmationModal: {
      deleteTitle: 'Radera annons',
      deleteDescription: 'Är du säker på att du vill radera annonsen?',
    },
    errors: {
      notFound: {
        title: 'Annonsen kunde inte hittas',
        subtitle: 'Du försökte gå in på en annons som inte finns.',
      },
    },
    flashMessage: {
      updateListingSuccess: 'Annons uppdaterad',
      updateListingFailure: 'Annonsen kunde inte uppdateras',
      deleteListingSuccess: 'Annons raderad',
      deleteListingFailure: 'Annonsen kunde inte raderas',
    },
  },
  createUpdateHouseRuleForm: {
    labels: {
      subject: 'Ämne',
      rule: 'Regel',
    },
  },
  invoiceView: {
    title: 'Fakturering',
    subtitle: 'Hantera dina fakturor och betalningsalternativ',
    tabBar: {
      payment: 'Betalning',
      details: 'Uppgifter',
    },
    neighbourhood: {
      title: 'Grannskap använder Boappa gratis!',
    },
    details: {
      title: 'Fakturainformation',
      alert: 'Fakturor skickas via mejl',
      form: {
        labels: {
          recipient: 'Fakturamottagare',
          billingStreet: 'Adressrad 2',
        },
      },
    },
    basic: {
      remember: 'Kom ihåg!',
      payYourAnnualFee: 'Betala årsavgiften.',
      locked: {
        title: 'Föreningen är låst.',
        title_lgh: 'Fastigheten är låst.',
        subtitle: 'Betala årsavgiften för att fortsätta använda Boappa.',
      },
    },
    premium: {
      great: 'Toppen!',
      annualFeePayed: 'Ert abonnemang är aktivt.',
      paymentPlan: 'Betalplan',
      invoiceSentTo: 'Fakturan skickas till',
      untilNextPayment: 'till nästa faktura',
    },
    commonCard: {
      annualFee: 'Årsavgift',
      excludingVat: 'Exklusive moms',
      buttons: {
        useCode: 'Använd kod',
      },
      missingEmail: {
        title: 'Mejladress saknas.',
        description: 'Innan du betalar måste du ',
        link: 'uppdatera din mejladress',
      },
    },
    accordions: {
      title: 'Relaterade frågor',
      premium: {
        sections: {
          discountCode: {
            title: 'Har du använt en rabattkod?',
            text: 'Rabattkoden gäller tillsvidare och så länge samarbetet med partnern är aktivt.',
          },
        },
      },
      basic: {
        sections: {
          bostadsratterna: {
            title: 'Medlem hos Bostadsrätterna',
            text: 'Aktuell rabattkod finns i inloggat läge på Bostadsrätternas hemsida. Erbjudandet gäller så länge medlemskapet är aktivt.',
          },

          samfalligheterna: {
            title: 'Samfälligheterna',
            text: 'Mejla samfalligheter@villaagarna.se för att få er rabattkod.',
          },
        },
      },
      common: {
        sections: {
          paymentInstructions: {
            title: 'Betalningsinstruktioner',
            preLinkText: 'Läs guiden med',
          },
          termsOfService: {
            title: 'Tjänstevillkor',
            preTermsText: 'Tjänsten levereras i enlighet med våra',
            preDataProcessingText: 'och',
          },
          cancelSubscription: {
            title: 'Avsluta medlemskap',
            text: 'Kontakta support@boappa.se ifall ni vill avsluta tjänsten.',
          },
        },
      },
    },
    modals: {
      payment: {
        title: 'Betalning',
      },
      discountCode: {
        title: 'Rabattkod',
        informationSection: {
          title: 'Var hittar jag en rabattkod?',
          text: 'För att få använda Boappa med rabatt krävs det att föreningen är medlem hos Bostadsrätterna. Du hittar koden i inloggat läge på Bostadsrätternas hemsida.',
          text_samf:
            'För att erhålla 50% rabatt i Boappa krävs det att er förening har tecknat ett Trygghetsavtal hos Samfälligheterna (en tjänst från Villaägarna). Mejla samfalligheter@villaagarna.se för att få er rabattkod.',
        },
      },
    },
    forms: {
      payment: {
        sections: {
          invoiceDetails: 'Faktureringsuppgifter',
          orderInformation: 'Orderinformation',
        },
        labels: {
          yearlyCost: 'Kostnad för årsavgift',
          validity: 'Validitet',
        },
        cost: {
          totalCost: 'Total kostnad inkl. moms',
          vat: 'Varav moms',
        },
        agreement: {
          preUserAgreement: 'Jag har rätt att binda min förening och godkänner',
          preUserAgreement_lgh:
            'Jag har rätt att binda min fastighet och godkänner',
          postUserAgreement: 'inklusive bilaga',
          userAgreement: 'Användarvillkoren',
          termsOfService: 'Tjänstevillkoren',
          personalDataAgreement: 'Personuppgiftsbiträdesavtal',
        },
        errors: {
          upgradeErrored:
            'Det gick inte att beställa. Vänligen kontakta support@boappa.se',
        },
      },
      discountCode: {
        labels: {
          discountCode: 'Uppge din rabattkod',
        },
        errors: {
          discountCode: 'Ogiltig rabattkod',
        },
        placeholders: {
          discountCode: 'Skriv koden här...',
        },
      },
    },
    flashMessage: {
      discountCodeApplied: 'Rabattkoden har applicerats',
      upgradeSuccess: 'Föreningen har uppgraderats',
    },
  },
  createUpdateHouseRule: {
    addNewHouseRuleTitle: 'Skapa ny regel',
    editHouseRuleTitle: 'Redigera regel',
    flashMessage: {
      updateHouseRuleSuccess: 'Regel uppdaterad',
      updateHouseRuleFailure: 'Regel kunde inte uppdateras',
      createHouseRuleSuccess: 'Regel skapad',
      createHouseRuleFailure: 'Regel kunde inte skapas',
      deleteHouseRuleSuccess: 'Regel raderad',
      deleteHouseRuleFailure: 'Regeln kunde inte raderas',
    },
    confirmationModal: {
      title: 'Radera trivselregel',
      description: 'Är du säker på att du vill radera regeln?',
    },
  },
  createUpdateQuestionsAndAnswers: {
    addNewQuestionTitle: 'Ny fråga',
    editQuestionTitle: 'Redigera fråga',
    addNewSectionTitle: 'Skapa ny sektion',
    editSectionTitle: 'Redigera sektion',
    flashMessage: {
      updateQuestionSuccess: 'Fråga uppdaterad',
      updateQuestionFailure: 'Fråga kunde inte uppdateras',
      createQuestionSuccess: 'Fråga skapad',
      createQuestionFailure: 'Fråga kunde inte skapas',
      deleteQuestionSuccess: 'Fråga raderad',
      deleteQuestionFailure: 'Frågan kunde inte raderas',
      updateSectionSuccess: 'Sektion uppdaterad',
      updateSectionFailure: 'Sektion kunde inte uppdateras',
      createSectionSuccess: 'Sektion skapad',
      createSectionFailure: 'Sektion kunde inte skapas',
      deleteSectionSuccess: 'Sektion raderad',
      deleteSectionFailure: 'Sektionen kunde inte raderas',
    },
    confirmationModal: {
      title: 'Radera fråga',
      description: 'Är du säker på att du vill radera frågan?',
    },
    removeSectionConfirmationModal: {
      title: 'Radera sektion',
      description: 'Är du säker på att du vill radera sektionen?',
    },
  },
  createUpdateQuestionsAndAnswersItemForm: {
    labels: {
      question: 'Fråga',
      answer: 'Svar',
    },
  },
  createUpdateQuestionsAndAnswersSectionForm: {
    labels: {
      section: 'Titel',
    },
  },
  notifications: {
    title: 'Notiser',
    emptyState: 'Här visas notiser om vad som händer i appen.',
    newTicketFromBoard:
      'Ett nytt ärende från styrelsen {% ticketTitle %} har skapats.',
    newTicket: 'Ett nytt ärende {% ticketTitle %} har skapats.',
    ticketOpen: 'Ärende {% ticketTitle %} har öppnats.',
    ticketClosed: 'Ärende {% ticketTitle %} har stängts.',
    ticketAssigned: 'Du har blivid tilldelad ett ärende {% ticketTitle %}.',
    newGroupChat:
      'Gruppchatten {% roomName %} har skapats. Kolla vad som diskuteras.',
    newPost: `{% userName %} skapade ett inlägg: "{% message %}"`,
    newComment: '{% userName %} kommenterade ett inlägg: "{% comment %}"',
    newCommentYourPost:
      '{% userName %} kommenterade ditt inlägg: "{% comment %}"',
    newLike: '{% userName %} gillade ditt inlägg: "{% message %}"',
    newProblemReport: 'En felanmälan har skickats till din mejladress',
    societyActivated: '{% societyName %} aktiverades i Boappa!',
    societyInvite: 'Du har blivit inbjuden till {% societyName %}',
    societyRequest:
      '{% userName %} begär att få tillgång till {% societyName %}',
    societyRequestAccepted: 'Du har fått tillgång till {% societyName %}',
    societyRequestAcceptedAdmin:
      '{% userName %} har fått tillgång till {% societyName %}',
    newInspiration: 'Läs om månadens inspiration från andra Boappare.',
    chatNewChannel:
      'Gruppchatten {% roomName %} har skapats. Kolla vad som diskuteras.',
    contractMonitoring:
      'Bevakningsdatumet har infallit för avtalet {% contractTitle %}',
    newBinderDocument:
      'Ett nytt dokument har lagts till i bopärmen: {% unitName %}',
    newBinderFolder: 'En ny mapp har lagts till i bopärmen: {% unitName %}',
    newBinderInformation:
      'Ny information har lagts till i bopärmen: {% unitName %}',
  },
  searchBar: {
    placeholder: {
      search: 'Sök...',
      filter: 'Filtrera...',
    },
  },
  dropZone: {
    dragFileHere: 'Dra filen hit eller',
    clickToSelect: 'klicka för att välja fil',
    acceptedFormats: 'Accepterade filformat',
    dragFolderHere: 'Dra startmappen hit eller',
    folderDescriptionNotePrefix:
      'Beskrivning för en mapp ska vara en textfil med namnet ',
    folderDescriptionName: 'folderDescription.md',
    folderDescriptionNoteSuffix: ' eller txt.',
    folderThumbnailNotePrefix:
      'Bild för en mapp ska vara en bildfil med namnet ',
    folderThumbnailName: 'folderThumbnail.png',
    folderThumbnailNoteSuffix: ' eller jpeg/jpg/webp.',
    clickToSelectFolder: 'klicka för att välja mapp',
  },
  createUpdateContactModal: {
    addNewContactTitle: 'Skapa ny kontakt',
    editContactTitle: 'Redigera kontakt',
    flashMessage: {
      updateContactSuccess: 'Kontakt uppdaterad',
      updateContactFailure: 'Kontakten kunde inte uppdateras',
      createContactSuccess: 'Kontakt skapad',
      createContactFailure: 'Kontakten kunde inte skapas',
    },
  },
  createUpdateContractModal: {
    addNewContractTitle: 'Skapa nytt avtal',
    editContractTitle: 'Redigera avtal',
    flashMessage: {
      updateContractSuccess: 'Avtal uppdaterat',
      updateContractFailure: 'Avtalet kunde inte uppdateras',
      createContractSuccess: 'Avtal skapat',
      createContractFailure: 'Avtalet kunde inte skapas',
    },
  },
  createUpdateContractForm: {
    labels: {
      title: 'Titel',
      company: 'Företag',
      description: 'Beskrivning',
      running: 'Löpande',
      startDate: 'Startdatum',
      endDate: 'Slutdatum',
      notificationDate: 'Bevakningsdatum',
      status: 'Status',
      documents: 'Dokument',
      contactName: 'Namn',
      contactEmail: 'Mejladress',
      contactPhone: 'Telefonnummer',
      contactWebsite: 'Hemsida',
    },
    headers: {
      contactDetails: 'Kontaktuppgifter',
      documents: 'Dokument',
    },
    status: {
      active: 'Aktivt',
      terminated: 'Avslutat',
    },
  },
  createUpdateDocument: {
    addNewDocumentTitle: 'Ladda upp dokument',
    editDocumentTitle: 'Redigera dokument',
    flashMessage: {
      updateDocumentSuccess: 'Dokument uppdaterat',
      updateDocumentFailure: 'Dokumentet kunde inte uppdateras',
      createDocumentPluralSuccess: 'Dokumenten skapades',
      createDocumentPluralFailure: 'Dokumenten kunde inte skapas',
      createDocumentSingularSuccess: 'Dokument skapat',
      createDocumentSingularFailure: 'Dokument kunde inte skapas',
      deleteDocumentSuccess: 'Dokument raderat',
      deleteDocumentFailure: 'Dokumentet kunde inte raderas',
    },
    removeDocumentConfirmationModal: {
      title: 'Radera dokument',
      description: 'Är du säker på att du vill radera dokumentet?',
    },
  },
  createUpdateDocumentForm: {
    labels: {
      name: 'Namn',
    },
    uploadedFiles: 'Uppladdade filer',
  },
  createUpdateBinderForm: {
    filesToBeUploaded: 'Mappar/filer att ladda upp ({{numberOfFiles}})',
  },
  documentsList: {
    allDocuments: 'All föreningsinformation',
    allDocuments_lgh: 'All hyresgästinformation',
    allBoardDocuments: 'Alla styrelsedokument',
    allBoardDocuments_lgh: 'Alla förvaltardokument',
    emptyState: {
      noSearchResultSubtitle:
        'Inga sökresultat hittades. Försök igen eller ändra ditt sökord.',
      title: 'Du har inget att läsa',
      emptyFolderSubtitle:
        'Just nu finns det inga dokument publicerade i "{{folderName}}". När styrelsen delar rapporter, anteckningar och relevant dokumentation kommer det dyka upp här.',
      emptyFolderSubtitle_lgh:
        'Just nu finns det inga dokument publicerade i "{{folderName}}". När förvaltaren delar rapporter, anteckningar och relevant dokumentation kommer det dyka upp här.',
      noDocumentsSubtitle:
        'Just nu finns det inga mappar eller dokument publicerade. När styrelsen delar rapporter, anteckningar och relevant dokumentation kommer det dyka upp här.',
      noDocumentsSubtitle_lgh:
        'Just nu finns det inga mappar eller dokument publicerade. När förvaltaren delar rapporter, anteckningar och relevant dokumentation kommer det dyka upp här.',
      emptyFolderSubtitleBoard:
        'Just nu finns det inga dokument publicerade i "{{folderName}}".',
      noDocumentsSubtitleBoard:
        'Just nu finns det inga mappar eller dokument publicerade.',
    },
    document: {
      folderSingular: 'mapp',
      folderPlural: 'mappar',
      documentSingular: 'dokument',
      documentPlural: 'dokument',
    },
  },
  binderList: {
    binders: 'Bopärm',
    rootFolderDescription:
      'Här visas dokument för bostaden {{societyName}}, lägenhet {{unitNbr}}',
    emptyState: {
      noSearchResultSubtitle:
        'Inga sökresultat hittades. Försök igen eller ändra ditt sökord.',
      title: 'Du har inget att läsa',
      emptyBinder: 'Just nu finns det inga dokument publicerade i bopärmen',
      emptyFolderSubtitle:
        'Just nu finns det inga dokument publicerade i "{{folderName}}".',
      noDocumentsSubtitle:
        'Just nu finns det inga mappar eller dokument publicerade.',
    },
  },
  createUpdateFolder: {
    addNewFolderTitle: 'Skapa ny mapp',
    editFolderTitle: 'Redigera mapp',
    flashMessage: {
      updateFolderSuccess: 'Mapp uppdaterad',
      updateFolderFailure: 'Mappen kunde inte uppdateras',
      createFolderSuccess: 'Mapp skapad',
      createFolderFailure: 'Mappen kunde inte skapas',
      deleteFolderSuccess: 'Mapp raderad',
      deleteFolderFailure: 'Mappen kunde inte raderas',
    },
    removeFolderConfirmationModal: {
      title: 'Radera mapp',
      description: 'Är du säker på att du vill radera mappen?',
    },
  },
  createUpdateFolderForm: {
    labels: {
      name: 'Namn',
      thumbnail: 'Bild',
    },
  },
  deleteContract: {
    flashMessage: {
      deleteContractSuccess: 'Avtal raderat',
      deleteContractFailure: 'Avtalet kunde inte raderas',
    },
    removeContractConfirmationModal: {
      title: 'Radera avtal',
      description: 'Är du säker på att du vill radera avtalet?',
    },
  },
  widgetView: {
    emptyState: {
      title: 'Funktionen kunde inte hittas',
      subtitle: 'Du försökte gå in på en funktion som inte finns.',
    },
  },
  createUpdateAdminModal: {
    addNewAdminTitle: 'Lägg till administratör',
    flashMessage: {
      adminAddSuccessSingular: 'Administratör tillagd',
      adminAddFailureSingular: 'Administratör kunde inte läggas till',
      adminAddSuccessPlural: 'Administratörer tillagda',
      adminAddFailurePlural: 'Administratörer kunde inte läggas till',
    },
  },
  createUpdateBoardMemberModal: {
    addNewBoardMemberTitle: 'Lägg till styrelsemedlem',
    addNewBoardMemberTitle_lgh: 'Lägg till förvaltare',
    editBoardMemberTitle: 'Redigera styrelsemedlem',
    editBoardMemberTitle_lgh: 'Redigera förvaltare',
    flashMessage: {
      createRoleSuccess: 'Rollen har skapats',
      createRoleFailure: 'Rollen kunde inte skapas',
      updateRoleSuccess: 'Rollen har uppdaterats',
      updateRoleFailure: 'Rollen kunde inte uppdateras',
    },
  },
  createUpdateAdminForm: {
    labels: {
      users: 'Användare',
    },
    error: {
      minItems: 'Måste välja minst en användare',
    },
  },
  createUpdateBlockedUserModal: {
    title: 'Lägg till blockering',
  },
  createUpdateBlockedUserForm: {
    labels: {
      users: 'Användare',
    },
    error: {
      minItems: 'Välj minst en användare',
    },
  },
  createUpdateBoardMemberForm: {
    labels: {
      role: 'Roll',
      user: 'Användare',
    },
  },
  boardListView: {
    title: 'Styrelsemedlemmar',
    title_lgh: 'Förvaltare',
    addBoardMember: 'Lägg till styrelsemedlem',
    addBoardMember_lgh: 'Lägg till förvaltare',
    alert: {
      deleteBoardMemberTitle: 'Radera styrelsemedlem',
      deleteBoardMemberTitle_lgh: 'Radera förvaltare',
      deleteBoardMemberText:
        'Är du säker på att du vill radera styrelsemedlemmen?',
      deleteBoardMemberText_lgh:
        'Är du säker på att du vill radera förvaltaren?',
    },
    emptyState: {
      title: 'Det finns inga styrelsemedlemmar',
      title_lgh: 'Det finns inga förvaltare',
      subtitle: 'Inga styrelsemedlemmar har lagts till i föreningen.',
      subtitle_lgh: 'Inga förvaltare har lagts till i fastigheten.',
    },
    flashMessage: {
      deleteBoardMemberSuccess: 'Styrelsemedlemmen raderad',
      deleteBoardMemberSuccess_lgh: 'Förvaltaren raderad',
      deleteBoardMemberFailure: 'Styrelsemedlemmen kunde inte raderas',
      deleteBoardMemberFailure_lgh: 'Förvaltaren kunde inte raderas',
    },
  },
  boardListItem: {
    dropdown: {
      editRole: 'Redigera roll',
    },
  },
  createUpdateContactForm: {
    labels: {
      coverPhoto: 'Omslagsbild',
      name: 'Namn',
      title: 'Titel',
      description: 'Beskrivning',
      phoneNumber: 'Telefonnummer',
      emailAddress: 'Mejladress',
      website: 'Hemsida',
    },
    headers: {
      contactDetails: 'Kontaktuppgifter',
    },
  },
  adminView: {
    title: 'Admin',
    tabBar: {
      users: 'Användare',
      societies: 'Föreningar',
      societies_lgh: 'Fastigheter',
      actions: 'Actions',
      discountCodes: 'Rabattkoder',
      logInAsUser: 'Logga in som användare',
      pendingInvoices: 'Väntande fakturor',
      extractData: 'Ladda ner utdrag',
      auditLogs: 'Audit logs',
      webinars: 'Webinars',
    },
    searchBar: {
      placeholders: {
        users: 'Sök på mejladress eller id',
        societies: 'Sök på namn eller id',
        auditLogs: 'Sök på föreningsid',
        auditLogs_lgh: 'Sök på fastighetsid',
      },
    },
    searchResult: {
      emptyResult: 'Inget resultat.',
    },
  },
  manageHousehold: {
    modalTitle: 'Bjud in personer',
    title: 'Hushåll',
    subtitle:
      'Här du kan bjuda in familjemedlemmar, inneboende och hyresgäster som ska ha tillgång till appen men som inte är medlemmar i föreningen.',
    subtitle_lgh:
      'Här du kan bjuda in familjemedlemmar, inneboende och hyresgäster som ska ha tillgång till appen men som inte är medlemmar i fastigheten.',
    form: {
      headers: {
        household: 'Personer i hushållet',
        pendingInvites: 'Obesvarade inbjudningar',
      },
    },
    buttons: {
      addPerson: 'Lägg till person',
    },
    reminder: {
      confirmationModal: {
        title: 'Skicka påminnelse',
        description: 'Vill du skicka en påminnelseinbjudan till {{ email }}?',
      },
    },
    errorViews: {
      noSociety: {
        title: 'Du är inte med i en förening',
        title_lgh: 'Du är inte med i en fastighet',
        subtitle:
          'För att hantera ditt hushåll måste du vara med i en förening och ha en tilldelad enhet.',
        subtitle_lgh:
          'För att hantera ditt hushåll måste du vara med i en fastighet och ha en tilldelad enhet.',
      },
    },
    flashMessage: {
      sendInviteSuccess: 'Person inbjuden',
      sendInviteFailure: 'Inbjudan kunde inte skickas',
      userReminderFailure: 'Påminnelsen kunde inte skickas',
      userReminderSuccess: 'Påminnelse skickad',
    },
  },
  postCreateUpdateBase: {
    form: {
      placeholders: {
        message: 'Hej härliga förening....',
        message_lgh: 'Hej härliga fastighet....',
        society: 'Välj förening',
        society_lgh: 'Välj fastighet',
      },
    },
    media: {
      attach: 'Bifoga',
      images: 'Bilder',
      documents: 'Dokument',
    },
    attachments: {
      pictures: 'Dina bilder',
      gallery: 'Bildkatalog',
      document: 'Dokument',
      event: 'Händelse',
      poll: 'Omröstning',
    },
    roleSheet: {
      admin: 'Admin',
      board: 'Styrelse',
      board_lgh: 'Förvaltare',
    },
    visibilitySheet: {
      all: 'Alla',
      board: 'Styrelsen',
      board_lgh: 'Förvaltaren',
      admin: 'Administratörer',
    },
    navigationHeaders: {
      polls: 'Omröstningar',
      documents: 'Dokument',
      events: 'Händelser',
      images: 'Bilder',
    },
    alert: {
      imageDeleteTitle: 'Radera bild',
      imageDeleteText: 'Är du säker på att du vill radera bilden?',
      documentDeleteTitle: 'Radera dokument',
      documentDeleteText: 'Är du säker på att du vill radera dokumentet?',
      eventDeleteTitle: 'Radera händelse',
      eventDeleteText: 'Är du säker på att du vill radera händelsen?',
      pollDeleteTitle: 'Radera omröstning',
      pollDeleteText: 'Är du säker på att du vill radera omröstningen?',
    },
    flashMessage: {
      updatePostSuccess: 'Inlägg uppdaterat',
      updatePostFailure: 'Inlägget kunde inte uppdateras',
      createPostSuccess: 'Inlägg skapat',
      createPostFailure: 'Inlägget kunde inte skapas',
    },
  },
  society: {
    roles: {
      admin: 'Admin',
      board: 'Styrelsen',
      board_lgh: 'Förvaltaren',
    },
    boardRoles: {
      advisor: 'Adjungerad',
      alternate: 'Suppleant',
      chairman: 'Ordförande',
      member: 'Styrelseledamot',
      nominatingCommittee: 'Valberedning',
      secretary: 'Sekreterare',
      treasury: 'Kassör',
      viceChairman: 'Vice ordförande',
    },
    postedBy: 'via',
  },
  authenticationSignInView: {
    title: 'Inloggning',
    welcome: 'Välkommen till Boappa',
    form: {
      labels: {
        email: 'Mejladress',
        password: 'Lösenord',
      },
      placeholders: {
        email: 'Ange din mejladress',
      },
    },
    signInButtonTitle: 'Logga in',
    createAccountButtonTitle: 'Skapa konto',
    forgotPasswordButtonTitle: 'Har du glömt lösenordet?',
    flashMessage: {
      signInFailure: 'Fel lösenord eller mejladress',
      signInFailureHint: 'Har du glömt lösenordet, eller inte valt något än?',
    },
  },
  authenticationSignUpView: {
    title: 'Skapa konto',
    subTitle:
      'Du kan här skapa ett användarkonto i Boappa om du inte har det sedan tidigare. Kontot är personligt, så använd din privata mejladress. Mejladressen är ditt användarnamn i Boappa och används för inloggning. Efter inloggning kan du starta upp en ny förening för en gratis provperiod i Boappa eller ansöka om medlemskap i en befintlig Boappa‑förening.',
    subTitle_lgh:
      'Du kan här skapa ett användarkonto i Boappa om du inte har det sedan tidigare. Kontot är personligt, så använd din privata mejladress. Mejladressen är ditt användarnamn i Boappa och används för inloggning. Efter inloggning kan du starta upp en ny fastighet för en gratis provperiod i Boappa eller ansöka om medlemskap i en befintlig Boappa‑fastighet.',
    form: {
      labels: {
        name: 'Förnamn',
        surname: 'Efternamn',
        email: 'Mejladress',
      },
      placeholders: {
        name: 'Ange ditt förnamn',
        surname: 'Ange ditt efternamn',
        email: 'Ange din privata mejladress',
      },
      checkboxText: {
        legalAge: 'Jag har fyllt 18 år eller har målmans godkännande',
        termsOfService:
          'Jag godkänner Boappas {{termsOfUse}} och har läst Boappas {{privacyPolicy}}',
        termsOfUseTitle: 'Användarvillkor',
        privacyPolicyTitle: 'Integritetspolicy',
      },
    },
    signUpButtonTitle: 'Skapa konto',
    loginButtonTitle: 'Har du redan ett konto?',
    loginCTAButtonTitle: 'Logga in',
    forgotPasswordButtonTitle: 'Har du glömt lösenordet?',
    flashMessage: {
      verificationEmailSent: 'Mejlet har skickats!',
    },
  },
  authenticationResetPasswordView: {
    title: 'Återställ lösenord',
    linkExpiredTitle: 'Länken fungerar inte längre',
    linkExpiredSubtitle:
      'Den kan ha gått ut, redan använts eller ersatts av en nyare. Fyll i din mejladress nedan så skickar vi en ny.',
    form: {
      labels: {
        email: 'Mejladress',
        emailConfirmation: 'Upprepa mejladress',
      },
    },
    resetPasswordButtonTitle: 'Återställ lösenord',
    confirmationScreen: {
      title: 'Kolla din mejl',
      preEmailText: 'Om adressen är registrerad har vi skickat ett mejl till:',
      instructionText:
        'Följ anvisningarna i mejlet för att välja ett nytt lösenord. Hittar du inget mejl? Titta i skräpposten.',
    },
    flashMessage: {
      passwordResetSuccess: 'Mejlet har skickats!',
      passwordResetFailure: 'Lösenordet kunde inte återställas',
    },
  },
  authenticationRetrievePasswordView: {
    title: 'Återställ lösenord',
    subtitle: 'Välj ett nytt lösenord till ditt konto. Sedan är du inloggad.',
    form: {
      labels: {
        password: 'Nytt lösenord',
      },
    },
    retrievePasswordButtonTitle: 'Ändra lösenord',
    problemsWithLink: 'Fungerar inte länken?',
    sendNewLink: 'Skicka en ny länk',
    flashMessage: {
      passwordResetSuccess: 'Lösenordet har ändrats',
      passwordResetFailure: 'Länken fungerade inte',
    },
  },
  societyCreateUpdateContactScreens: {
    flashMessage: {
      updateContactSuccess: 'Kontakt uppdaterad',
      updateContactFailure: 'Kontakten kunde inte uppdateras',
      createContactSuccess: 'Kontakt skapad',
      createContactFailure: 'Kontakten kunde inte skapas',
    },
  },
  societyCreateUpdateResourceScreens: {
    flashMessage: {
      updateResourceSuccess: 'Annons uppdaterad',
      updateResourceFailure: 'Annonsen kunde inte uppdateras',
      createResourceSuccess: 'Annons skapad',
      createResourceFailure: 'Annonsen kunde inte skapas',
    },
  },
  createUpdateResourceModal: {
    title: 'Skapa ny annons',
    labels: {
      media: 'Bild',
      title: 'Titel',
      description: 'Beskrivning',
      cost: 'Pris',
    },
    placeholders: {
      description: 'Beskriv objektet i annonsen',
    },
  },
  settingsView: {
    title: 'Mitt konto',
    tabBar: {
      tabs: {
        myInfo: 'Min info',
        changePassword: 'Ändra lösenord',
        notificationSettings: 'Notiser',
      },
    },
  },
  changeLanguage: {
    title: 'Språk',
  },
  profileSettings: {
    title: 'Konto',
    profilePictureTitle: 'Profilbild',
    labels: {
      updateProfilePicture: 'Ändra',
    },
    confirmationModal: {
      title: 'Radera profilbild',
      description: 'Är du säker på att du vill radera profilbilden?',
    },
    flashMessage: {
      updateProfilePictureSuccess: 'Profilbild uppdaterad',
      updateProfilePictureFailure: 'Profilbilden kunde inte uppdateras',
      deleteProfilePictureSuccess: 'Profilbild borttagen',
      deleteProfilePictureFailure: 'Profilbilden kunde inte tas bort',
    },
    deleteAccount: {
      title: 'Radera konto',
      text: 'Följ nästkommande steg för att permanent radera ditt konto',
    },
  },
  changeEmail: {
    title: 'Byt mejladress',
    text: 'Vi skickar en bekräftelselänk till den nya adressen. Bytet sker först när du öppnar länken.',
    labels: {
      currentEmail: 'Nuvarande mejladress',
      newEmail: 'Ny mejladress',
      repeatNewEmail: 'Upprepa mejladress',
    },
    flashMessage: {
      updateEmailFailure: 'Mejladressen kunde inte uppdateras',
      updateEmailSuccess: 'Mejlet har skickats!',
    },
  },
  changePassword: {
    title: 'Ändra lösenord',
    labels: {
      currentPassword: 'Nuvarande lösenord',
      newPassword: 'Nytt lösenord',
    },
    flashMessage: {
      updatePasswordFailure: 'Lösenordet kunde inte uppdateras',
      updatePasswordSuccess: 'Lösenordet uppdaterat',
    },
  },
  myInfo: {
    sections: {
      titles: {
        general: 'Generell information',
        work: 'Arbete',
        education: 'Utbildning',
        about: 'Om mig',
        interests: 'Intressen',
      },
    },
  },
  boappaSuperadmin: {
    title: 'Supportverktyg',
    userTitle: 'Användare',
    logout: 'Logga ut som användare',
    signin: 'Logga in som användare',
    labels: {
      search: 'Sök på mejladress eller id',
      searchButton: 'Sök',
      matches: 'Matchningar',
      firstname: 'Förnamn:',
      lastname: 'Efternamn:',
      verified: 'Bekräftad mejladress:',
      email: 'Mejladress:',
    },
  },
  notificationSettings: {
    options: {
      mobile: 'Mobil',
      email: 'Mejl',
    },
    sections: {
      all: {
        title: 'Alla notiser',
        allNotificationsTitle: 'Stäng av/slå på samtliga notiser',
      },
      admin: {
        title: 'Administratör',
        membershipRequestTitle: 'Förfrågningar om medlemskap',
      },
      feed: {
        title: 'Flöde',
        boardNewPostTitle: 'Inlägg från styrelsen',
        boardNewPostTitle_lgh: 'Inlägg från förvaltaren',
        boardNewCommentTitle: 'Kommentarer på inlägg från styrelsen',
        boardNewCommentTitle_lgh: 'Kommentarer på inlägg från förvaltaren',
        neighbourNewPostTitle: 'Inlägg från grannar',
        neighbourNewCommentTitle: 'Kommentarer på grannars inlägg',
      },
      chat: {
        title: 'Chatt',
        neighbourNewMessageTitle: 'Grannchatt',
        groupNewMessageTitle: 'Gruppchatt',
        boardNewMessageTitle: 'Styrelsechatt',
        boardNewMessageTitle_lgh: 'Förvaltarchatt',
        questionsNewMessageTitle: 'Fråga styrelsen chatt',
        questionsNewMessageTitle_lgh: 'Fråga förvaltaren chatt',
      },
      ticket: {
        title: 'Ärende',
        forMeAsResidentTitle: 'För mig som boende:',
        forMeInBoardTitle: 'För mig i Styrelsen:',
        newMessageFromBoard: 'Nytt meddelande i chatt med styrelsen',
        newTicketFromBoard: 'Nytt ärende från styrelsen',
        newTicket: 'Nytt ärende från boende',
        newMessage: 'Nytt meddelande i chatt med boende',
      },
    },
  },
  findFriends: {
    numberMatchesSingular: 'Träff',
    numberMatchesPlural: 'Träffar',
    categories: {
      interests: 'Intressen',
      occupationAndEducation: 'Arbete & Utbildning',
    },
  },
  form: {
    requiredNote: '*Obligatoriskt',
    lockedNote: 'Låst',
    errors: {
      required: 'Fältet är obligatoriskt',
      unknown: 'Felaktigt värde',
      invalidEmail: 'Felaktig mejladress',
      invalidWebsite: 'Felaktigt webbadressformat',
      emailConfirmation: 'Mejladresserna måste vara lika',
      emailSameAsCurrent: 'Det är redan mejladressen till ditt konto',
      minLength: 'Måste vara minst {{minLength}} tecken',
      minNumber: 'Måste vara minst {{minNumber}}',
      emailAlreadyInUse: 'Mejladressen används redan.',
      matches: 'Felaktigt format',
      organisationNumber:
        'Organisationsnumret måste bestå av 10 siffror. Exempel: 123456-7890',
    },
  },
  flashMessage: {
    changesSaved: 'Ändringar sparade',
    changesNotSavedError: 'Ändringarna kunde inte sparas',
    somethingWentWrongError: 'Något gick fel',
    tooManyAttemptsError:
      'För många försök just nu. Titta i skräpposten, och försök igen om en stund.',
    tooManyAttemptsTryLaterError:
      'För många försök just nu. Försök igen om en stund.',
    somethingWentWrongTryAgainError: 'Något gick fel. Försök igen.',
    cannotOpenEmail: 'Kan inte öppna mejlklienten. Mejla till: {% email %}',
    chatSocketError:
      'Något gick fel när meddelandet skulle skickas. Testa att ladda om sidan eller försök igen senare.',
  },
  errorBoundary: {
    errorFallbackTitle: 'Hoppsan, något gick fel!',
    errorFallbackSubtitle:
      'Felet har rapporteras till våra utvecklare och kommer åtgärdas snarast.\n\nFör att underlätta felsökningen skulle vi uppskatta om du rapporterar buggen.',
    reportBugButtonTitle: 'Rapportera bugg',
  },
  user: {
    name: 'Namn',
    surname: 'Efternamn',
    gender: 'Kön',
    phoneNumber: 'Telefonnummer',
    birthDate: 'Födelsedatum',
    aboutInfo: {
      presentation: 'Presentation',
      presentationPlaceholder: 'Beskriv dig själv...',
      interestCategories: 'Kategorier',
      occupation: {
        company: 'Företag',
        title: 'Titel',
        industry: 'Industri',
      },
      education: {
        level: 'Nivå',
        country: 'Land',
        institute: 'Institut',
        field: 'Utbildning',
        degree: 'Examen',
      },
    },
  },
  education: {
    level: {
      highSchool: 'Gymnasium',
      professionalSchool: 'Yrkesskola',
      university: 'Universitet',
    },
    degree: {
      bachelor: 'Kandidat/Högskola',
      master: 'Master/Magister',
      phd: 'Licentiat/Doktor',
    },
    field: {
      airPilot: 'Pilot',
      animalKeeper: 'Djursjukskötare',
      architecture: 'Arkitektur',
      bachelorOfEngineeering: 'Högskoleingenjör',
      bioMedicine: 'Biomedicinsk analytiker',
      business: 'Civilekonom',
      civilEngineering: 'Byggingenjör',
      dentalHygiene: 'Tandhygienist',
      dentist: 'Tandläkare',
      dietetics: 'Dietist',
      engineering: 'Civilingenjör',
      environmentalScience: 'Miljövetare',
      finance: 'Ekonomi',
      fireScience: 'Brandman- och brandingenjör',
      forestry: 'Jägmästare',
      forestEngineering: 'Skogsmästare',
      healthScience: 'Hälsovetenskap',
      hippology: 'Hippolog',
      humanities: 'Humaniora',
      humanResources: 'Personalvetare',
      journalism: 'Journalist',
      law: 'Jurist',
      libraryAndInformationScience: 'Biblioteks- och informationsvetenskap',
      logistics: 'Logistik',
      marineScience: 'Sjökapten',
      mediaAndCommunicationScience: 'Medie- och kommunikationsvetenskap',
      medicalDoctor: 'Läkare',
      natureScience: 'Naturvetare',
      nursing: 'Sjuksköterska',
      occupationalTherapy: 'Arbetsterapeut',
      optometry: 'Optiker',
      pharmacist: 'Apotekare',
      physiotherapy: 'Sjukgymnastik',
      police: 'Polis',
      psychology: 'Psykolog',
      realEstate: 'Fastighetsmäklare',
      socialAndBehaviouralScience: 'Beteendevetare',
      socialScience: 'Samhällsvetare',
      socialWorkEducation: 'Socionom',
      softwareDeveloper: 'Webbutveckling och programmering',
      statistics: 'Statistik',
      systemsEngineering: 'Systemvetare',
      teacher: 'Lärare',
      theology: 'Teologi',
      veterinary: 'Veterinär',
    },
  },
  occupation: {
    industry: {
      marketing: 'Försäljning, marknad, reklam',
      adminOfficeManagement: 'Kontor, Administration',
      healthcare: 'Hälso-, Sjukvård, Omsorg',
      customerSupport: 'Kundtjänstarbeten',
      humanResourcesLegal: 'HR, juridik',
      serviceRetailTourism: 'Service, Handel, Butik',
      financeBankingInsurance: 'Ekonomi, Finans, Försäkring',
      education: 'Utbildning',
      industryProduction: 'Industri, produktion',
      itData: 'IT, data',
      engineering: 'Civilingenjör',
      logisticsPurchasing: 'Inköp, Transport, Logistik',
      management: 'Management',
      environment: 'Miljövård',
      construction: 'Bygg, Anläggning',
      cultureMedia: 'Kultur, Media',
    },
  },
  interests: {
    actionSports: 'Extremsport',
    animals: 'Djur',
    art: 'Konst',
    boardGames: 'Sällskapsspel',
    cars: 'Bilar',
    cooking: 'Matlagning',
    dancing: 'Dans',
    design: 'Design',
    electronicsSmartHomes: 'Elektronik/smarta hem',
    entrepreneurship: 'Entreprenörskap',
    family: 'Familj',
    film: 'Film',
    fitness: 'Fitness',
    gardening: 'Trädgård/odling',
    handicraft: 'Hantverk',
    literature: 'Litteratur',
    motorcycles: 'Motorcyklar',
    music: 'Musik',
    nature: 'Natur',
    outdoors: 'Friluftsliv',
    painting: 'Måla',
    politics: 'Politik',
    reading: 'Böcker',
    religion: 'Religion',
    sports: 'Sport',
    startups: 'Startups',
    stockTrading: 'Aktiehandel',
    tech: 'Teknologi',
    toddlers: 'Småbarnsliv',
    travel: 'Resa',
  },
  genders: {
    male: 'Man',
    female: 'Kvinna',
    other: 'Annat',
  },
  societySideBar: {
    sections: {
      resident: {
        title: 'Boende',
        neighborhoodTitle: 'Grannskap',
        residentFunctionsTitle: 'För dig som boende',
        residentFunctionsTitle_lgh: 'För dig som hyresgäst',
      },
      board: {
        title: 'Styrelseportalen',
        title_lgh: 'Förvaltningsportalen',
        managementTitle: 'Styrelsearbete',
        managementTitle_lgh: 'Förvaltning',
        adminTitle: 'Admin',
      },
    },
    searchBar: {
      placeholder: 'Sök i menyn...',
    },
    items: {
      labels: {
        leaveSociety: 'Lämna förening',
        leaveSociety_lgh: 'Lämna fastighet',
      },
    },
    callouts: {
      gettingStarted: {
        title: 'Kom igång',
      },
      getToKnow: {
        title: 'Lär känna Boappa',
      },
      incompleteRegister: {
        title: 'Ofullständigt lägenhetsregister',
        title_samf: 'Ofullständigt fastighetsregister',
      },
      societyLocked: {
        title: 'Föreningen är låst',
        title_lgh: 'Fastigheten är låst',
      },
      societyTrial: {
        titleDays: '{{ days }} dag kvar av provperioden',
        titleDaysPlural: '{{ days }} dagar kvar av provperioden',
      },
    },
  },
  chatRoomsSidebar: {
    startNewChat: 'Starta ny',
    startNewInterestsChat: 'Starta ny',
    startNewAskBoardChat: 'Ställ fråga',
    startNewAskBoardChat_lgh: 'Ställ fråga',
    startNewBoardChat: 'Starta ny',
    startNewBoardChat_lgh: 'Starta ny',
    joinGroupChat: 'Gå med',
    findQuestionsChat: 'Arkiv',
    message: {
      userSentImageText: 'Du skickade en bild',
      otherUserSentImageText: '{{name}} skickade en bild',
    },
    activeTabBar: {
      resident: 'Boende',
      board: 'Styrelse',
      board_lgh: 'Förvaltare',
    },
    tabs: {
      oneOnOneAndInterestsTitle: 'Chatt',
      oneOnOneTitle: 'Grannar',
      InterestsTitle: 'Gruppchatt',
      questionsTitle: 'Fråga styrelsen',
      questionsTitle_lgh: 'Fråga förvaltaren',
      boardTitle: 'Styrelsechatt',
      boardTitle_lgh: 'Förvaltarchatt',
      answerResidentsTitle: 'Svara boende',
    },
    createNewMessage: {
      title: 'Nytt meddelande',
    },
    createNewMessageForm: {
      labels: {
        sendTo: 'Till:',
      },
      search: {
        placeholder: 'Ange namn',
        moreHint: 'Skriv för att begränsa listan',
      },
      error: {
        minItems: 'Måste välja minst en användare',
      },
    },
  },
  chatRooms: {
    chatDisabled: {
      title: 'Chatten avstängd',
      subtitle: 'Styrelsen har stängt av chatten mellan grannar',
    },
    userHasNoChats: {
      title: 'Ingen chatt startad ännu',
      subtitle:
        'Tips: Har mjölken tagit slut till kaffet eller har du glömt bort tiden till grillfesten? Passa på att chatta och fråga grannen om hjälp.',
    },
    userHasNoGroupChats: {
      subtitle:
        'Starta en öppen eller stängd gruppchatt med dina grannar, eller kolla under "Gå med" om det redan finns en chatt du är intresserad av.',
    },

    ticketEnabledResident: {
      title: 'Fråga styrelsen har flyttat',
      title_lgh: 'Fråga förvaltaren har flyttat',
      subtitle: 'Du hittar nu funktionen som Ärenden under Föreningsfliken',
      subtitle_lgh: 'Du hittar nu funktionen som Ärenden under Förvaltarfliken',
    },
    ticketEnabledBoard: {
      title: 'Svara boende har flyttat',
      title_lgh: 'Fråga förvaltaren har flyttat',
      subtitle:
        'Du hittar nu funktionen som Ärendehantering i Styrelseportalen',
      subtitle_lgh:
        'Du hittar nu funktionen som Ärendehantering under Förvaltarfliken',
    },
    noBoardQuestions: {
      title: 'Ingen fråga ställd ännu',
      subtitle:
        'Tips: Har du en fråga om hur man ställer sig i kön till en garageplats i föreningen? Ställ då din fråga till styrelsen här.',
      subtitle_lgh:
        'Tips: Har du en fråga om hur man ställer sig i kön till en garageplats i fastigheten? Ställ då din fråga till förvaltaren här.',
    },
    noBoardChats: {
      title: 'Ingen styrelsechatt startad ännu',
      title_lgh: 'Ingen förvaltarchatt startad ännu',
      subtitle:
        'Tips: Här kan ni exempelvis diskutera pågående projekt och kommande styrelsemöten.',
      subtitle_lgh:
        'Tips: Här kan ni exempelvis diskutera pågående projekt och kommande styrelsemöten.',
    },
    noBoardAnswerResidentChats: {
      title: 'Ingen fråga ställd ännu',
      subtitle: 'Här kan ni som styrelse besvara de boendes frågor.',
      subtitle_lgh: 'Här kan ni som förvaltare besvara de boendes frågor.',
    },
    noChatSelected: {
      title: 'Du har inte valt någon chatt ännu',
      subtitle:
        'Välj en befintlig chatt eller starta en ny konversation för att komma igång.',
    },
    pendingRequest: {
      subtitle:
        'Här kommer du kunna chatta med dina grannar så fort din förfrågan är godkänd.',
    },
  },
  chatSettings: {
    actions: {
      add: 'Lägg till:',
    },
    actionSheet: {
      changeChatRoomImage: 'Ändra chattbild',
      deleteChatRoomImage: 'Ta bort chattbild',
    },
    form: {
      title: 'Gruppmedlemmar',
      remove: 'Radera chatt',
      groupChatName: 'Namn',
      chatCreator: 'Skapare',
      society: 'Förening',
      society_lgh: 'Fastighet',
      type: 'Typ',
      closedGroupChat: 'Stängd gruppchatt',
      openGroupChat: 'Öppen gruppchatt',
      members: 'Medlemmar',
      showMembers: 'Visa gruppmedlemmar',
      noMembersFound: 'Inga personer hittades',
      leave: 'Lämna chatt',
      archive: 'Arkivera',
    },
    tables: {
      titles: {
        groupChatInfo: 'Gruppinformation',
        addMembers: 'Lägg till medlemmar',
        actions: 'Åtgärder',
      },
    },
    alert: {
      chatRoomDeleteTitle: 'Ta bort chatt',
      chatRoomDeleteText: 'Är du säker på att du vill ta bort chatten?',
      leaveChatRoomTitle: 'Lämna gruppchatt',
      leaveChatRoomText: 'Är du säker på att du vill lämna gruppchatten?',
      archiveChatRoomTitle: 'Arkivera chatt',
      archiveChatRoomText: 'Är du säker på att du vill arkivera chatten?',
      chatRoomMemberDeleteTitle: 'Ta bort från gruppchatt',
      chatRoomMemberDeleteText:
        'Är du säker på att vill ta bort denna person från gruppchatten?',
    },
    flashMessage: {
      deleteChatRoomSuccess: 'Chatt borttagen',
      deleteChatRoomFailure: 'Chatten kunde inte tas bort',
      leaveChatRoomSuccess: 'Lämnade gruppchatten',
      leaveChatRoomFailure: 'Kunde inte lämna gruppchatten',
      archiveChatRoomSuccess: 'Chatt arkiverad',
      archiveChatRoomFailure: 'Kunde inte arkivera chatten',
      deleteChatRoomMemberSuccess: 'Personen borttagen',
      deleteChatRoomMemberFailure: 'Personen kunde inte tas bort',
      addChatRoomMembersSuccess: 'Medlemmar tillagda',
      addChatRoomMembersFailure: 'Medlemmarna kunde inte läggas till',
    },
  },
  startNewChat: {
    openGroupChat: 'Öppen gruppchatt',
    closedGroupChat: 'Stängd gruppchatt',
    changeToGroupChat: 'Ändra till gruppchatt',
    groupChatInputLabel: 'Gruppnamn:',
    boardChatInputLabel: 'Ämne:',
  },
  managementDocumentsView: {
    title: 'Styrelsedokument',
    title_lgh: 'Förvaltardokument',
    addNewFolder: 'Skapa ny mapp',
    editFolder: 'Redigera mapp',
    addNewDocument: 'Ladda upp dokument',
    bostadsratternaFolderStructure: 'Mappstruktur',
    flashMessage: {
      createBostadsratternaFolderStructureSuccess: 'Mappstruktur skapad',
      createBostadsratternaFolderStructureFailure:
        'Mappstrukturen kunde inte skapas',
    },
  },
  managementBinderView: {
    title: 'Bopärmar',
    addNewFolder: 'Skapa ny mapp',
    addNewDocument: 'Ladda upp mappar med undermappar och filer',
    uploadFoldersBtn: 'Ladda upp mappar',
    uploadDocumentsBtn: 'Ladda upp dokument',
    addNewDocumentTitle: 'Ladda upp dokument och filer',
    editDocumentTitle: 'Redigera dokument',
    flashMessage: {
      publishBinderSuccess: 'Bopärmen har publicerats',
      publishBinderFailure: 'Bopärmen kunde inte publiceras',
      unPublishBinderSuccess: 'Bopärmen har avpublicerats',
      unPublishBinderFailure: 'Bopärmen kunde inte avpubliceras',
    },
    uploadThumbnailInvalidType:
      'Endast bildfiler (jpg, jpeg, png, webp) kan användas som thumbnail-bilder',
    uploadDescriptionInvalidType:
      'Endast md och txt filer kan användas som beskrivningar',
  },
  unitPickerView: {
    title: 'Välj bostad',
  },
  binderPickerView: {
    title: 'Välj bostad',
    publishButton: 'Publicera',
    unpublishButton: 'Avpublicera',
    uploadButtonFolders: 'Ladda upp mappar',
    uploadButtonDocuments: 'Ladda upp dokument',
    exportCsvButton: 'Exportera CSV',
    csv: {
      folder: 'Mapp',
      folderDescription: 'Mappbeskrivning',
      document: 'Dokument',
    },
    flashMessage: {
      exportCsvFailure: 'Det gick inte att exportera CSV-filen',
    },
    searchBar: {
      placeholder: 'Filtrera på adress eller lgh-nr',
    },
    table: {
      adress: 'Adress',
      aptNumber: 'Lägenhetsnummer',
      floor: 'Våning',
      area: 'Boarea',
      room: 'Antal rum',
      folderAndDocs: 'Mappar/dokument',
      published: 'Publicerad',
    },
    tooltip: {
      title: 'Filen finns redan',
      text_one:
        'Filen finns redan i bostaden: {{units}}.\nFilen kommer att skrivas över om du fortsätter med uppladdningen.',
      text_other:
        'Filen finns redan i bostäderna: {{units}}.\nFilen kommer att skrivas över om du fortsätter med uppladdningen.',
      // text: 'Filen finns redan i {{count, plural, one {bostaden} other {bostäderna}}}: {{units}}.\nFilen kommer att skrivas över om du fortsätter med uppladdningen.',
      // text: 'Filen finns redan i bostaden/bostäderna: {{units}}.\nFilen kommer att skrivas över om du fortsätter med uppladdningen.',
    },
  },
  binderView: {
    title: 'Bopärm',
    addNewFolder: 'Skapa ny mapp',
    addNewDocument: 'Ladda upp dokument',
  },
  documentsView: {
    title: 'Föreningsinformation',
    title_lgh: 'Hyresgästinformation',
    addNewFolder: 'Skapa ny mapp',
    editFolder: 'Redigera mapp',
    addNewDocument: 'Ladda upp dokument',
  },
  unitRoles: {
    member: 'Boende (ägare)',
    resident: 'Boende',
    tentant: 'Hyresgäst',
    relative: 'Släkting/vän',
    propertyManager: 'Fastighetsskötare',
    customerRepresentative: 'Kundansvarig',
    other: 'Annat',
  },
  joinGroupChat: {
    joinHeader: 'Gå med i gruppchatt',
    join: 'Gå med',
    details: 'Detaljer',
    backToGroupChats: 'Tillbaka till gruppchattar',
    flashMessage: {
      joinGroupChatSuccess: 'Gick med i gruppchatt',
      joinGroupChatFailure: 'Kunde inte gå med i gruppchatt',
    },
  },
  publicGroups: {
    header: 'Öppna gruppchattar',
    errorViews: {
      noGroups: {
        title: 'Inga öppna gruppchattar att gå med i',
        subtitle:
          'Här visas öppna gruppchattar i dina föreningar som du inte har gått med i ännu.',
      },
    },
  },
  findArchivedChats: {
    header: 'Aktivera arkiverad chatt',
    errorViews: {
      noChatRooms: {
        title: 'Det finns inga arkiverade chattar',
        subtitle: 'Här kan du aktivera dina arkiverade chattar igen.',
      },
    },
    flashMessage: {
      activateArchivedChatSuccess: 'Arkiverad chatt aktiverad',
      activateArchivedChatFailure: 'Kunde inte aktivera chatt',
    },
  },
  chatAskBoardNewMessage: {
    title: 'Fråga styrelsen',
    form: {
      labels: {
        subject: 'Ämne',
        message: 'Meddelande',
      },
    },
    media: {
      attachImageButtonLabel: 'Bifoga bild',
      imageHeaderTitle: 'Bilder',
    },
    flashMessage: {
      sendQuestionSuccess: 'Fråga skickad',
      sendQuestionFailure: 'Kunde inte skicka fråga',
    },
  },
  chatUpload: {
    flashMessage: {
      uploadImageLimitReached:
        'Du kan endast ladda upp 10 bilder per chattmeddelande',
      uploadDocumentLimitReached:
        'Du kan endast ladda upp 10 dokument per chattmeddelande',
    },
  },
  societyManagementWebsiteImages: {
    title: 'Bilder',
    headers: {
      primaryImageTitle: 'Huvudbild',
      societyImagesTitle: 'Bilder som visas på hemsidan',
    },
    addImagesButton: 'Lägg till bild',
    addImageDescription: 'Lägg till beskrivning',
    showImagesLabel: 'Visa',
    recommendedPrimaryImageSizeText:
      'Rekommenderad minsta bildstorlek: 1280x800 pixlar',
  },
  mediaGallery: {
    imageGalleryPositionLabel: 'Bild',
    imageDownloadSuccessText: 'Bild nedladdad',
    downloadImageButtonText: 'Ladda ner bild',
  },
  leaveSociety: {
    confirmationModal: {
      title: 'Lämna förening',
      title_lgh: 'Lämna fastighet',
      description: 'Är du säker på att du vill lämna föreningen?',
      description_lgh: 'Är du säker på att du vill lämna fastigheten?',
    },
    unableToLeaveModal: {
      title: 'Du kan inte lämna föreningen',
      title_lgh: 'Du kan inte lämna fastigheten',
      description:
        'För att lämna föreningen måste du första lämna över rollen som huvudadministratör till någon annan.',
      description_lgh:
        'För att lämna fastigheten måste du första lämna över rollen som huvudadministratör till någon annan.',
    },
    flashMessage: {
      leaveSocietySuccess: 'Förening lämnad',
      leaveSocietySuccess_lgh: 'Fastighet lämnad',
      leaveSocietyFailure: 'Kunde inte lämna föreningen',
      leaveSocietyFailure_lgh: 'Kunde inte lämna fastigheten',
    },
  },
  reportProblemSpace: {
    apartment: 'Lägenheten',
    building: 'Byggnaden',
    surroundings: 'Området',
    commonAreas: 'Gemensamma utrymmen',
    other: 'Annat',
  },
  pollEditor: {
    form: {
      labels: {
        title: 'Fråga',
        type: 'Omröstningstyp',
      },
      placeholders: {
        option: 'Alternativ',
      },
      headers: {
        options: 'Svarsalternativ',
      },
      buttons: {
        addMoreOptionsButtonTitle: 'Lägg till svarsalternativ',
        exportVotesButtonTitle: 'Ladda ner resultat',
      },
    },
    label: {
      perUser: 'Per användare',
      perHousehold: 'Per hushåll',
    },
    pollDescription: 'Beskrivning',
  },
  poll: {
    votesSingular: 'röst',
    votesPlural: 'röster',
    showResults: 'Visa resultat',
    vote: 'Rösta',
    regretVote: 'Ångra röst',
    householdAlreadyVoted: 'Ditt hushåll har redan röstat',
    userAlreadyVoted: 'Du har redan röstat',
    anonymousVoting: 'Anonym omröstning',
    nonAnonymousVoting: 'Ej anonym omröstning',
    result: 'Ladda ner resultat',
    flashMessage: {
      updatePollSuccess: 'Omröstning uppdaterad',
      updatePollFailure: 'Omröstningen kunde inte uppdateras',
      createPollSuccess: 'Omröstning skapad',
      createPollFailure: 'Omröstningen kunde inte skapas',
      exportVotesFailure: 'Omröstningen kunde inte exporteras',
    },
    csv: {
      option: 'Val',
      votes: 'Röster',
      name: 'Namn',
      unit: 'Bostad',
    },
  },
  createSocietyTypeSelectionView: {
    title: 'Skapa förening',
    title_lgh: 'Skapa fastighet',
    header: 'Så här enkelt kommer du igång med din förening i',
    header_lgh: 'Så här enkelt kommer du igång med din fastighet i',
    paragraph:
      'Du som företräder styrelsen i din förening kan enkelt registrera er förening i Boappa. Därefter får ni prova Boappa med alla dess funktioner under 60 dagar utan kostnad och utan vidare förpliktelser. Vi förutsätter att ni avsätter tid och gör ett allvarligt försök att lära känna Boappa.',
    paragraph_lgh:
      'Du som företräder styrelsen i din fastighet kan enkelt registrera er fastighet i Boappa. Därefter får ni prova Boappa med alla dess funktioner under 60 dagar utan kostnad och utan vidare förpliktelser. Vi förutsätter att ni avsätter tid och gör ett allvarligt försök att lära känna Boappa.',
    paragraph2:
      'Skulle ni fastna så vet ni att vi gör allt för att ni ska komma igång på bästa sätt. Det finns mängder av guider i vår <GuideLink>Kunskapsbank</GuideLink>, och boka gärna plats till online–utbildningarna Boappa Introduktion och Boappa Kom–igång <DemoLink>här</DemoLink>, eller kontakta vår <SupportLink>support</SupportLink>.',
    paragraph3: 'Vilken typ av förening vill du aktivera?',
    paragraph3_lgh: 'Vilken typ av fastighet vill du aktivera?',
    labels: {
      housingCooperative:
        'Bostadsrättsförening, bostadsförening eller ägarlägenheter',
      homeownersAssociation: 'Samfällighet eller vägförening',
      realEstateDeveloper: 'Bostadsutvecklarprojekt',
      neighbourhood: 'Grannskap',
    },
    findSociety:
      'Vill du istället gå med i en förening? Ansök om medlemskap <Link>här</Link>',
    findSociety_lgh:
      'Vill du istället gå med i en fastighet? Ansök om medlemskap <Link>här</Link>',
  },
  societyInviteBanner: {
    invited: 'Du är inbjuden till {{societyName}}',
    details: 'Se inbjudan',
  },
  reportPost: {
    title: 'Rapportera inlägg',
    subtitle:
      'Boappas mål är att hjälpa till att förbättra grannsämjan. Inga trakasserier tillåts. Rapportera inlägg som inte följer detta till administratören.',
    form: {
      labels: {
        message: 'Meddelande',
      },
    },
    flashMessage: {
      reportSuccess: 'Inlägget har rapporterats',
      reportFailure: 'Inlägget kunde inte rapporteras',
    },
    buttons: {
      submitTitle: 'Rapportera',
    },
  },
  societyRoot: {
    subtitle: 'Här hittar du genvägar till olika funktioner i din förening',
    subtitle_lgh:
      'Här hittar du genvägar till olika funktioner i din fastighet',
    shortcutTitle: 'Genvägar',
    offersTitle: 'Erbjudanden',
    titles: {
      residentList: 'Boendelista',
      boardDocuments: 'Styrelsedokument',
      boardDocuments_lgh: 'Förvaltardokument',
      register: 'Register',
      societyWebsite: 'Föreningshemsida',
      societyWebsite_lgh: 'Fastighetshemsida',
    },
    subtitles: {
      residentList: 'Här kan du se vilka som bor i din förening',
      residentList_lgh: 'Här kan du se vilka som bor i din fastighet',
      boardDocuments: 'Skapa mappar och ladda upp dokument',
      boardDocuments_lgh: 'Skapa mappar och ladda upp dokument',
      register: 'Bjud in era grannar, hantera adresser och lägenhetsnummer',
      societyWebsite: 'Redigera er nya hemsida efter just era önskemål',
    },
    onboardingButtonTitle: 'Du kan enkelt hitta tillbaka till guiden här',
  },
  onboardingView: {
    title: 'Välkommen till {{societyName}}!',
    subtitle: 'Kom igång med din förening',
    subtitle_lgh: 'Kom igång med din fastighet',
    explanationTitle:
      'Denna guide ger dig inblick hur navigeringen fungerar på fliken Förening',
    explanationTitle_lgh:
      'Denna guide ger dig inblick hur navigeringen fungerar på fliken Fastighet',
    explanationText:
      'Vi går igenom Dokument, Register, Frågor & Svar och föreningshemsidan. Du kan enkelt hitta tillbaka till guiden genom att klicka på knappen på föreningsstartsidan.',
    explanationText_lgh:
      'Vi går igenom Dokument, Register, Frågor & Svar och fastighetshemsidan. Du kan enkelt hitta tillbaka till guiden genom att klicka på knappen på fastighetsstartsidan.',
    skipText: 'Klar? Klicka för att hoppa över guiden',
    onboardingSections: {
      documents: {
        title: 'Styrelsedokument',
        title_lgh: 'Förvaltardokument',
        subtitle:
          'Ladda upp dokument som delas i din förening. För att skapa er egna första mapp klicka på “skapa mapp” eller “ladda upp dokument” för att komma igång.',
        subtitle_lgh:
          'Ladda upp dokument som delas i din fastighet. För att skapa er egna första mapp klicka på “skapa mapp” eller “ladda upp dokument” för att komma igång.',
      },
      register: {
        title: 'Register',
        subtitle:
          'Bjud in era styrelsekollegor och grannar. Klicka på knappen “Bjud in medlemmar” inne på register för att påbörja inbjudningsprocessen. Ni kan även använda en excel-fil för att ladda upp flera adresser åt gången.',
        subtitle_lgh:
          'Bjud in era förvaltarkollegor och hyresgäster. Klicka på knappen “Bjud in hyresgäster inne på register för att påbörja inbjudningsprocessen. Ni kan även använda en excel-fil för att ladda upp flera adresser åt gången.',
      },
      faq: {
        title: 'Frågor och svar',
        subtitle:
          'Lägg upp bra och nyttig information som era grannar i föreningen kan ta del av. Här kan ni till exempel ange information kring balkong, yttre- och inre utrymmen som är bra att veta.',
        subtitle_lgh:
          'Lägg upp bra och nyttig information som era hyresgäster i fastigheten kan ta del av. Här kan ni till exempel ange information kring balkong, yttre- och inare utrymmen som är bra att veta.',
      },
      societyWebsite: {
        title: 'Föreningshemsida',
        title_lgh: 'Fastighetshemsida',
        subtitle:
          'Ange information och bilder till er helt egna föreningshemsida. Här kan ni ladda upp årsredovisningar, dokument och bilder som är relevant för just er förening. Detta kan även underlätta för mäklare när de behöver hitta information om just er förening.',
        subtitle_lgh:
          'Ange information och bilder till er helt egna fastighetshemsida. Här kan ni ladda upp årsredovisningar, dokument och bilder som är relevant för just er fastighet. Detta kan även underlätta för mäklare när de behöver hitta information om just er fastighet.',
      },
    },
  },
  onboardingSection: {
    step: 'Steg {{step}}',
    nextStep: 'Nästa steg',
    previousStep: 'Föregående steg',
    lastStep: 'Klar! Stäng guide',
  },
  gettingStartedCompletedScreen: {
    title: 'Grattis! Nu är ni igång med Boappa på riktigt',
    description:
      'Utforska nu på egen hand och se till att medlemmarna aktiverar sig.',
    button: 'Börja Boappa!',
    restartGuide:
      'Skulle ni vilja starta om Kom igång med Boappa-guiden, hittar ni den under Styrelseportalen -> Admin -> Kom igång med Boappa',
  },
  getToKnowCompletedScreen: {
    title: 'Härligt! Nu har ni provat på Boappas kommunikationsverktyg',
    description:
      'Är ni redo att förbereda och köra igång Boappa för hela föreningen? Häng då med i nästa guide',
    description_lgh:
      'Är ni redo att förbereda och köra igång Boappa för hela fastigheten? Häng då med i nästa guide',
    button: 'Kom igång med Boappa',
    restartGuide:
      'Skulle ni vilja starta om Lär känna Boappa-guiden, hittar ni den under Styrelseportalen -> Admin -> Lär känna Boappa',
  },
  getToKnowScreen: {
    title: 'Lär känna Boappa - på 5 minuter',
    description:
      'Som administratör kan du snabbt komma igång med Boappas kommunikationsverktyg i några enkla steg',
    completedView: {
      description:
        'Om ni behöver friska upp minnet kan ni köra om Lär känna boappa guiden igen',
      description_lgh:
        'Om ni behöver friska upp minnet kan ni köra om Lär känna boappa guiden igen',
      button: 'Starta lär känna boappa guiden',
    },
    startGuide: {
      title: 'Lär känna Boappa - på 5 minuter',
      description:
        'Som administratör i föreningen är det viktigt att du känner till hur Boappas kommunikationsverktyg fungerar. I denna guide går vi igenom de viktigaste funktionerna.',
      description_lgh:
        'Som administratör i fastigheten är det viktigt att du känner till hur Boappas kommunikationsverktyg fungerar. I denna guide går vi igenom de viktigaste funktionerna.',
      button: 'Starta guiden',
    },
    screens: {
      button: {
        complete: 'Slutför steg',
        undo: 'Ångra steg',
      },
      board: {
        title: 'Bjud in styrelsekollegorna',
        title_lgh: 'Bjud in förvaltarkollegorna',
        description:
          'Klicka på "Bjud in medlem" uppe till höger och bjud in dina styrelsekollegor',
        description_lgh:
          'Klicka på "Bjud in hyresgäst" uppe till höger och bjud in dina förvaltarkollegor',
      },
      feed: {
        title: 'Skapa ett inlägg i flödet',
        description:
          'Klicka på "Skriv ett inlägg..." och skapa ett inlägg i flödet',
      },
      chat: {
        title: 'Chatta med styrelsen',
        title_lgh: 'Chatta med förvaltaren',
        description:
          'Klicka på menyn "Styrelse" och därefter på "+ Starta ny", skriv in ett Ämne -> skriv ett meddelande -> skicka (pilen till höger)',
        description_lgh:
          'Klicka på menyn "Förvaltare" och därefter på "+ Starta ny", skriv in ett Ämne -> skriv ett meddelande -> skicka (pilen till höger)',
      },
      calendar: {
        title: 'Skapa en kalenderhändelse',
        description: 'Lägg in ert nästa styrelsemöte i styrelsekalendern',
        description_lgh: 'Lägg in ert nästa förvaltarmöte i förvaltarkalendern',
      },
    },
    todosCompleted: {
      title: 'Bra jobbat!',
      description: 'Nu har du lärt känna Boappas kommunikationsverktyg',
      button: 'Avsluta guiden',
    },
    progress: '{{completed}} av {{total}} steg klara',
    todos: {
      board: {
        title: 'Bjud in styrelsekollegorna',
        title_lgh: 'Bjud in förvaltarkollegorna',
        description: 'Testa Boappa tillsammans med dina styrelsekollegor',
        description_lgh: 'Testa Boappa tillsammans med dina förvaltarkollegor',
      },
      feed: {
        title: 'Skapa ett inlägg i flödet',
        description:
          'Som styrelse och admin kan du även bifoga dokument, kalenderhändelser och omröstningar i flödet',
        description_lgh:
          'Som förvaltare och admin kan du även bifoga dokument, kalenderhändelser och omröstningar i flödet',
      },
      chat: {
        title: 'Chatta med styrelsen',
        title_lgh: 'Chatta med förvaltaren',
        description:
          'Chatta med dina styrelsekollegor genom att skapa en ny chatt och ge chatten ett ämne',
        description_lgh:
          'Chatta med dina förvaltarkollegor genom att skapa en ny chatt och ge chatten ett ämne',
      },
      calendar: {
        title: 'Skapa en kalenderhändelse',
        description: 'Lägg in ert nästa styrelsemöte i styrelsekalendern',
        description_lgh: 'Lägg in ert nästa förvaltarmöte i förvaltarkalendern',
      },
    },
  },
  gettingStartedScreen: {
    navigation: 'Kom igång med Boappa',
    title: 'Kom igång med Boappa - på riktigt!',
    description:
      'Som administratör kan du förbereda och köra igång Boappa för hela föreningen i några enkla steg',
    description_lgh:
      'Som administratör kan du förbereda och köra igång Boappa för hela fastigheten i några enkla steg',
    startGuide: {
      title: 'Kom igång med Boappa - på riktigt!',
      description:
        'I denna guide går vi igenom de viktigaste stegen för att komma igång med Boappa.',
      description_lgh:
        'I denna guide går vi igenom de viktigaste stegen för att komma igång med Boappa.',
      button: 'Starta guiden',
    },
    completedView: {
      description:
        'Om ni behöver friska upp minnet kan ni köra om kom igång guiden igen',
      description_lgh:
        'Om ni behöver friska upp minnet kan ni köra om kom igång guiden igen',
      button: 'Starta om kom igång guiden',
    },
    todosCompleted: {
      title: 'Bra jobbat!',
      description: 'Nu är er förening redo!',
      description_lgh: 'Nu är er fastighet redo!',
      button: 'Avsluta guiden',
    },
    progress: '{{completed}} av {{total}} steg klara',
    screens: {
      button: {
        complete: 'Slutför steg',
        undo: 'Ångra steg',
      },
      billing: {
        title: 'Aktivera abonnemanget',
        description:
          'Uppdatera faktureringsuppgifterna under fliken Uppgifter. Gå sen tillbaka till Betalning och klicka på betala',
      },
      register: {
        title: 'Skapa ett lägenhetsregister via knappen uppe till höger',
        title_samf: 'Skapa ett fastighetsregister via knappen uppe till höger',
        description:
          'Ladda ner mallen för Lägenhetsregistret via knappen, fyll i enligt instruktionerna och ladda upp på samma ställe.',
        description_samf:
          'Ladda ner mallen för Fastighetsregistret via knappen, fyll i enligt instruktionerna och ladda upp på samma ställe.',
      },
      functions: {
        title: 'Se över funktioner',
        description:
          'Gå igenom och välj vilka funktioner ni vill använda i Boappa, det kostar inget extra',
      },
      members: {
        title: 'Bjud in medlemmarna',
        title_lgh: 'Bjud in hyresgäster',
        description:
          'Ladda ner medlemsregistret, uppe till höger, fyll i enligt instruktioner och ladda upp på samma ställe. När du laddar upp medlemsregistret i Boappa då mejlas en inbjudan till samtliga mejladresser. För enskilda inbjudningar använda knappen "Bjud in medlem"',
        description_lgh:
          'Ladda ner hyresgästregistret, uppe till höger, fyll i enligt instruktioner och ladda upp på samma ställe. När du laddar upp hyresgästregistret i Boappa då mejlas en inbjudan till samtliga mejladresser. För enskilda inbjudningar använda knappen "Bjud in hyresgäst"',
      },
    },
    todos: {
      billing: {
        title: 'Aktivera abonnemanget',
        description:
          'Uppdatera faktureringsuppgifterna och kör igång ert årsabonnemang',
      },
      society_image: {
        title: 'Föreningens bild',
        title_lgh: 'Fastighetens bild',
        description:
          'Lägg till en bild på er förening. Den kommer visas här och som profilbild på era inlägg i flödet',
        description_lgh:
          'Lägg till en bild på er fastighet. Den kommer visas här och som profilbild på era inlägg i flödet',
      },
      register: {
        title: 'Lägenhetsregister',
        title_samf: 'Fastighetsregister',
        description:
          'Första gången du skapar ett lägenhetsregister kan du använda vår importfil (Excel)',
        description_samf:
          'Första gången du skapar ett fastighetsregister kan du använda vår importfil (Excel)',
      },
      functions: {
        title: 'Funktioner',
        description:
          'Välj först vilka funktioner som ni vill använda för föreningsmedlemmarna. Gå sedan in under För dig som boende och förbered  respektive funktion med information',
        description_lgh:
          'Välj först vilka funktioner som ni vill använda för hyresgäster. Gå sedan in under För dig som boende och förbered  respektive funktion med information',
      },
      members: {
        title: 'Bjud in medlemmarna',
        title_lgh: 'Bjud in hyresgäster',
        description:
          'Första gången du skapar ett medlemsregister kan du använda vår importfil (Excel)',
        description_lgh:
          'Första gången du skapar ett hyresgästregister kan du använda vår importfil (Excel)',
      },
    },
  },
  confirmEmailChangeView: {
    title: 'Bekräfta mejladress',
    pending: {
      title: 'Bekräftar din nya mejladress',
    },
    success: {
      title: 'Din mejladress har ändrats',
      subtitle:
        'Det är nu den här adressen du loggar in med, och den vi skickar allt till. Din tidigare adress fungerar inte längre.',
    },
    failure: {
      title: 'Länken fungerade inte',
      subtitle:
        'Den kan ha gått ut, redan använts eller ersatts av en nyare begäran. Ingenting har ändrats — ditt konto använder fortfarande sin tidigare mejladress. Logga in och begär bytet igen för att få en ny länk.',
    },
    limited: {
      title: 'För många försök just nu',
      subtitle: 'Länken fungerar fortfarande. Vänta en stund och försök igen.',
    },
    continueButtonTitle: 'Fortsätt till Boappa',
    loginButtonTitle: 'Logga in',
  },
  verifyEmailView: {
    title: 'Kolla din mejl',
    subtitle:
      'Klicka på länken i mejlet vi skickat för att välja ett lösenord och komma igång. Hittar du inget mejl? Titta först i skräpposten, annars skickar vi ett nytt nedan.',
    linkExpiredTitle: 'Länken fungerar inte längre',
    linkExpiredSubtitle:
      'Den kan ha gått ut, redan använts eller ersatts av en nyare. Fyll i din mejladress nedan så skickar vi en ny.',
    form: {
      labels: {
        email: 'Mejladress',
      },
    },
    sendAgain: 'Skicka länken igen',
    invalidEmail: 'Skrev du in fel mejladress?',
    setPassword: {
      title: 'Välj ett lösenord',
      subtitle:
        'Sista steget: välj ett lösenord till ditt konto. Sedan är du inloggad.',
      passwordLabel: 'Lösenord',
      submitButtonTitle: 'Välj lösenord och logga in',
      flashMessage: {
        success: 'Välkommen till Boappa!',
        failure: 'Länken fungerade inte',
      },
    },
    flashMessage: {
      resendVerifyEmailSuccess: 'Mejlet har skickats!',
      resendVerifyEmailFailure: 'Mejlet kunde inte skickas',
    },
    startOverButtonTitle: 'Börja om här',
  },
  deleteAccountModal: {
    title: 'Radera konto',
    warningTitle: 'Är du säker?',
    warningSubtitle: 'Ditt konto kommer att raderas permanent',
    secondWarningTitle: 'Radera konto',
    secondWarningText:
      'Kontot kommer raderas permanent och går inte att återskapa. Bekräfta ditt val genom att klicka på Fortsätt.',
    lastWarningTitle:
      'Skriv in ditt lösenord och klicka sedan på "Radera konto" för att radera ditt konto permanent',
    warningText:
      'Om du väljer att radera ditt konto går det inte att återskapa. Har du flyttat kan du istället välja att "Lämna förening".',
    warningText_lgh:
      'Om du väljer att radera ditt konto går det inte att återskapa. Har du flyttat kan du istället välja att "Lämna fastighet".',
    canNotDeleteTitle: 'Ditt konto kan inte raderas',
    canNotDeleteText:
      'Du måste först lämna över rollen som huvudadministratör till någon annan i föreningarna listade nedan innan du kan radera ditt konto.',
    canNotDeleteText_lgh:
      'Du måste först lämna över rollen som huvudadministratör till någon annan i fastigheterna listade nedan innan du kan radera ditt konto.',
    alert: {
      deleteAccountTitle: 'Radera konto',
      deleteAccountText:
        'Kontot kommer raderas permanent och går inte att återskapa. Bekräfta ditt val.',
    },
    flashMessage: {
      confirmPasswordFailure: 'Felaktigt lösenord',
      deleteAccountSuccess: 'Ditt konto har raderats',
    },
  },
  uploadImage: {
    invalidImageType:
      'Felaktigt bildformat, prova en annan bild eller ändra format',
  },
}

export default sv
